
// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   IconButton,
//   TextField,
//   InputAdornment,
//   Button,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Menu,
//   MenuItem,
//   ListItemIcon,
//   ListItemText,
//   Select,
//   FormControl,
//   InputLabel,
//   Alert,
//   Tab,
//   Tabs,
//   Grid,
//   Card,
//   CardContent,
//   Tooltip,
//   Avatar,
//   Divider,
//   Stack,
//   ToggleButtonGroup,
//   ToggleButton,
//   Pagination,
//   Switch,
//   FormControlLabel,
// } from '@mui/material';
// import {
//   Search,
//   Add,
//   Delete,
//   Warning as WarningIcon,
//   MoreVert,
//   Edit,
//   Restore,
//   DeleteSweep,
//   Business,
//   ErrorOutline,
//   Assessment,
//   CalendarToday,
//   TrendingUp,
//   TrendingDown,
//   Info as InfoIcon,
//   ViewList,
//   GridView,
//   Star,
//   StarBorder,
//   Close,
//   ChevronRight,
//   BugReport,
//   Description,
//   PlayArrow,
//   Person,
// } from '@mui/icons-material';
// import { useTheme as useMuiTheme } from '@mui/material/styles';
// import { useTheme as useCustomTheme } from '../../context/ThemeContext';
// import api from '../../services/api';
// import { useNavigate } from 'react-router-dom';

// interface Vendor {
//   id: string;
//   name: string;
//   domain: string;
//   score: number;
//   riskLevel: string;
//   lastScan: string;
//   createdAt: string;
//   lifecycle: 'due_diligence' | 'active_monitoring' | 'offboarding';
//   status: 'active' | 'cold';
//   deletedAt?: string | null;
//   category?: string;
//   business_units?: string[];
//   location?: string;
//   parent_company?: string;
//   vendor_since?: string;
//   ytd_spend?: number;
//   contact_name?: string;
//   contact_email?: string;
//   contact_phone?: string;
//   contract_end_date?: string;
//   contract_start_date?: string;
//   contract_value?: number;
//   auto_renew?: boolean;
//   renewal_notice_days?: number;
// }

// interface ExpiringContract {
//   id: string;
//   name: string;
//   end_date: string;
//   days_left: number;
//   notice_days: number;
//   contract_value: number | null;
//   auto_renew: boolean;
// }

// const LIFECYCLE_OPTIONS = [
//   { value: 'due_diligence', label: 'Due Diligence', color: '#f59e0b' },
//   { value: 'active_monitoring', label: 'Active Monitoring', color: '#10b981' },
//   { value: 'offboarding', label: 'Offboarding', color: '#ef4444' },
// ];

// const BUSINESS_UNIT_OPTIONS = ['IT', 'Operations', 'HR', 'Marketing', 'Finance', 'Legal', 'Sales', 'Admin'];

// const CATEGORY_OPTIONS = [
//   'Cloud Services', 'Technology Services', 'Logistics', 'Healthcare',
//   'Data & Analytics', 'Telecommunications', 'HR Services', 'IT Services',
//   'Finance', 'Legal', 'Cybersecurity', 'Payment Services', 'Facilities',
// ];

// const AVATAR_COLORS: Record<string, { bg: string; color: string }> = {
//   A: { bg: '#dbeafe', color: '#1d4ed8' }, B: { bg: '#ede9fe', color: '#7c3aed' },
//   C: { bg: '#dbeafe', color: '#1d4ed8' }, D: { bg: '#fce7f3', color: '#db2777' },
//   E: { bg: '#d1fae5', color: '#059669' }, F: { bg: '#fef3c7', color: '#d97706' },
//   G: { bg: '#fee2e2', color: '#dc2626' }, H: { bg: '#e0f2fe', color: '#0284c7' },
//   I: { bg: '#f3e8ff', color: '#9333ea' }, J: { bg: '#dcfce7', color: '#16a34a' },
//   K: { bg: '#fef9c3', color: '#ca8a04' }, L: { bg: '#ffe4e6', color: '#e11d48' },
//   M: { bg: '#e0f2fe', color: '#0369a1' }, N: { bg: '#f0fdf4', color: '#15803d' },
//   O: { bg: '#fff7ed', color: '#ea580c' }, P: { bg: '#fdf4ff', color: '#a21caf' },
//   Q: { bg: '#f0fdfa', color: '#0f766e' }, R: { bg: '#fff1f2', color: '#be123c' },
//   S: { bg: '#f0f9ff', color: '#0369a1' }, T: { bg: '#fefce8', color: '#a16207' },
//   U: { bg: '#f5f3ff', color: '#6d28d9' }, V: { bg: '#ecfdf5', color: '#047857' },
//   W: { bg: '#fef2f2', color: '#991b1b' }, X: { bg: '#eff6ff', color: '#1e40af' },
//   Y: { bg: '#fef9c3', color: '#92400e' }, Z: { bg: '#f0fdf4', color: '#166534' },
// };

// const getAvatarStyle = (name: string) => {
//   const letter = name?.charAt(0)?.toUpperCase() || 'A';
//   return AVATAR_COLORS[letter] || { bg: '#e2e8f0', color: '#475569' };
// };

// const getRiskColor = (level: string) => {
//   switch (level?.toLowerCase()) {
//     case 'critical': return '#dc2626';
//     case 'high': return '#ea580c';
//     case 'medium': return '#d97706';
//     case 'low': return '#16a34a';
//     case 'very low': return '#059669';
//     default: return '#64748b';
//   }
// };

// const getScoreColor = (score: number, riskLevel?: string) => {
//   if (riskLevel) {
//     switch (riskLevel?.toLowerCase()) {
//       case 'low':
//       case 'very low':
//         return '#16a34a';
//       case 'medium':
//         return '#d97706';
//       case 'high':
//       case 'critical':
//         return '#dc2626';
//       default:
//         break;
//     }
//   }
//   if (score >= 80) return '#16a34a';
//   if (score >= 60) return '#d97706';
//   return '#dc2626';
// };

// // ─── StatCard Component ──────────────────────────────────────────────────────
// interface StatCardProps {
//   title: string;
//   value: number | string;
//   trend?: { percentage: string; direction: 'up' | 'down' | 'flat' };
//   icon: React.ReactElement;
//   bgColor: string;
//   iconColor: string;
//   tooltip?: React.ReactNode;
//   themeColors: any;
// }

// const StatCard = ({ title, value, trend, icon, bgColor, iconColor, tooltip, themeColors }: StatCardProps) => (
//   <Card sx={{ 
//     borderRadius: 2, 
//     boxShadow: 'none', 
//     border: `1px solid ${themeColors.border}`, 
//     bgcolor: themeColors.cardBg, 
//     height: '100%' 
//   }}>
//     <CardContent sx={{ p: 2.5 }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//         <Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
//             <Typography variant="caption" sx={{ color: themeColors.muted, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: 10 }}>
//               {title}
//             </Typography>
//             {tooltip && (
//               <Tooltip title={tooltip} arrow>
//                 <InfoIcon sx={{ fontSize: 12, color: themeColors.muted, cursor: 'pointer' }} />
//               </Tooltip>
//             )}
//           </Box>
//           <Typography sx={{ fontWeight: 700, color: themeColors.text, fontSize: 26, lineHeight: 1 }}>
//             {typeof value === 'number' ? value.toLocaleString() : value}
//           </Typography>
//           {trend && (
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.75 }}>
//               {trend.direction === 'up'
//                 ? <TrendingUp sx={{ fontSize: 13, color: '#10b981' }} />
//                 : trend.direction === 'down'
//                 ? <TrendingDown sx={{ fontSize: 13, color: '#ef4444' }} />
//                 : <TrendingUp sx={{ fontSize: 13, color: themeColors.muted }} />}
//               <Typography variant="caption" sx={{ 
//                 color: trend.direction === 'up' ? '#10b981' : trend.direction === 'down' ? '#ef4444' : themeColors.muted, 
//                 fontWeight: 600, fontSize: 11 
//               }}>
//                 {trend.percentage}
//               </Typography>
//               <Typography variant="caption" sx={{ color: themeColors.muted, fontSize: 10 }}>vs last 30 days</Typography>
//             </Box>
//           )}
//         </Box>
//         <Avatar sx={{ bgcolor: bgColor, width: 42, height: 42, borderRadius: 2 }}>
//           <Box sx={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             justifyContent: 'center',
//             width: '100%',
//             height: '100%',
//             '& svg': { 
//               fontSize: 22, 
//               color: iconColor 
//             }
//           }}>
//             {icon}
//           </Box>
//         </Avatar>
//       </Box>
//     </CardContent>
//   </Card>
// );

// // ─── VendorDetailPanel Component ───────────────────────────────────────────
// interface VendorDetailPanelProps {
//   vendor: Vendor | null;
//   onClose: () => void;
//   onNavigate: (id: string) => void;
//   themeColors: any;
//   isDark: boolean;
// }

// const VendorDetailPanel = ({ vendor, onClose, onNavigate, themeColors, isDark }: VendorDetailPanelProps) => {
//   const [starred, setStarred] = useState(false);
//   if (!vendor) return null;
//   const avatarStyle = getAvatarStyle(vendor.name);

//   const getDaysUntilExpiry = (endDate: string | undefined | null): number | null => {
//     if (!endDate) return null;
//     const today = new Date();
//     const expiry = new Date(endDate);
//     const diffTime = expiry.getTime() - today.getTime();
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//     return diffDays;
//   };

//   const contractDaysLeft = getDaysUntilExpiry(vendor.contract_end_date);
//   const isExpiringSoon = contractDaysLeft !== null && contractDaysLeft <= (vendor.renewal_notice_days || 30);

//   return (
//     <Box
//       sx={{
//         width: 500,
//         flexShrink: 0,
//         bgcolor: themeColors.cardBg,
//         borderLeft: `1px solid ${themeColors.border}`,
//         display: 'flex',
//         flexDirection: 'column',
//       }}
//     >
//       <Box sx={{ flex: 1, overflowY: 'auto', p: 2.5 }}>
//         <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1.5 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
//             <Avatar
//               src={`https://www.google.com/s2/favicons?domain=${vendor.domain}&sz=64`}
//               sx={{ width: 36, height: 36, borderRadius: 2, bgcolor: avatarStyle.bg, color: avatarStyle.color, fontWeight: 700, fontSize: 15, flexShrink: 0 }}
//               imgProps={{ onError: (e) => { (e.target as HTMLImageElement).style.display = 'none'; } }}
//             >
//               {vendor.name?.charAt(0).toUpperCase()}
//             </Avatar>
//             <Box sx={{ minWidth: 0 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
//                 <Typography fontWeight={700} fontSize={14} color={themeColors.text} sx={{ lineHeight: 1.3, wordBreak: 'break-word' }}>
//                   {vendor.name}
//                 </Typography>
//                 <Chip
//                   label={vendor.status === 'active' ? 'Active' : 'Inactive'} 
//                   size="small"
//                   sx={{ 
//                     height: 20, 
//                     fontSize: 9, 
//                     bgcolor: vendor.status === 'active' ? '#22c55e' : (isDark ? '#2a2a2a' : '#e2e8f0'),
//                     fontWeight: 600, 
//                     borderRadius: 1,
//                     color: '#ffffff',
//                     '& .MuiChip-label': {
//                       color: vendor.status === 'active' ? '#ffffff' : (isDark ? '#f8fafc' : '#475569'),
//                       px: 1.5,
//                     }
//                   }}
//                 />
//               </Box>
//               <Typography fontSize={11} color={themeColors.muted} sx={{ mt: 0.25 }}>
//                 {vendor.category || 'Technology Services'}
//               </Typography>
//             </Box>
//           </Box>
//           <Box sx={{ display: 'flex', flexShrink: 0, ml: 0.5 }}>
//             <IconButton size="small" onClick={() => setStarred(!starred)} sx={{ p: 0.4 }}>
//               {starred ? <Star sx={{ fontSize: 16, color: '#f59e0b' }} /> : <StarBorder sx={{ fontSize: 16, color: themeColors.muted }} />}
//             </IconButton>
//             <IconButton size="small" onClick={onClose} sx={{ p: 0.4 }}>
//               <Close sx={{ fontSize: 16, color: themeColors.muted }} />
//             </IconButton>
//           </Box>
//         </Box>

//         <Box sx={{ display: 'flex', gap: 0.75, mb: 2, flexWrap: 'wrap' }}>
//           <Chip
//             label={`${vendor.riskLevel || 'High'} Risk`} 
//             size="small"
//             sx={{
//               bgcolor: getRiskColor(vendor.riskLevel) + '25',
//               color: getRiskColor(vendor.riskLevel),
//               fontWeight: 600, 
//               fontSize: 10, 
//               height: 22, 
//               borderRadius: 1,
//               border: `1px solid ${getRiskColor(vendor.riskLevel)}40`,
//               '& .MuiChip-label': {
//                 color: getRiskColor(vendor.riskLevel),
//                 px: 1.5,
//               }
//             }}
//           />
//           <Chip
//             label="Strategic Vendor" size="small"
//             sx={{ bgcolor: '#eff6ff', color: '#3b82f6', fontWeight: 600, fontSize: 10, height: 22, borderRadius: 1 }}
//           />
//         </Box>

//         <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 1, mb: 2 }}>
//           <Box sx={{ p: 1.5, bgcolor: isDark ? '#1a1a1a' : '#f8fafc', borderRadius: 1.5, border: `1px solid ${themeColors.border}` }}>
//             <Typography fontSize={10} color={themeColors.muted} fontWeight={500} sx={{ mb: 0.5 }}>Risk Score</Typography>
//             <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
//               <Typography fontSize={26} fontWeight={800} sx={{ color: getScoreColor(vendor.score, vendor.riskLevel), lineHeight: 1 }}>
//                 {vendor.score || 0}
//               </Typography>
//               <Typography fontSize={11} color={themeColors.muted}>/ 100</Typography>
//             </Box>
//           </Box>
//           <Box sx={{ p: 1.5, bgcolor: isDark ? '#1a1a1a' : '#f8fafc', borderRadius: 1.5, border: `1px solid ${themeColors.border}` }}>
//             <Typography fontSize={10} color={themeColors.muted} fontWeight={500} sx={{ mb: 0.5 }}>Risk Trend (30 days)</Typography>
//             <svg width="100%" height="32" viewBox="0 0 110 32" preserveAspectRatio="none">
//               <polyline
//                 points="0,26 20,20 40,23 60,13 80,16 100,9 110,6"
//                 fill="none" stroke="#ef4444" strokeWidth="1.8" strokeLinejoin="round"
//               />
//               <circle cx="110" cy="6" r="2.5" fill="#ef4444" />
//             </svg>
//           </Box>
//         </Box>

//         <Divider sx={{ mb: 1.75, borderColor: themeColors.border }} />

//         <Stack spacing={1.25} sx={{ mb: 2 }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={12} color={themeColors.muted}>Vendor ID</Typography>
//             <Typography fontSize={12} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.id?.slice(0, 8).toUpperCase() || '00000001'}
//             </Typography>
//           </Box>
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={12} color={themeColors.muted}>Business Unit</Typography>
//             <Typography fontSize={12} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.business_units?.length ? vendor.business_units.join(', ') : 'Not specified'}
//             </Typography>
//           </Box>
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={12} color={themeColors.muted}>Location</Typography>
//             <Typography fontSize={12} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.location || 'Not specified'}
//             </Typography>
//           </Box>
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={12} color={themeColors.muted}>Parent Company</Typography>
//             <Typography fontSize={12} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.parent_company || 'Not specified'}
//             </Typography>
//           </Box>
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={12} color={themeColors.muted}>Vendor Since</Typography>
//             <Typography fontSize={12} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.vendor_since ? new Date(vendor.vendor_since).toLocaleDateString() : 'Not specified'}
//             </Typography>
//           </Box>
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={12} color={themeColors.muted}>YTD Spend</Typography>
//             <Typography fontSize={12} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.ytd_spend ? `$${vendor.ytd_spend.toLocaleString()}` : 'Not specified'}
//             </Typography>
//           </Box>
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={12} color={themeColors.muted}>Contract Ends</Typography>
//             <Box sx={{ textAlign: 'right' }}>
//               <Typography fontSize={12} fontWeight={500} color={isExpiringSoon ? '#dc2626' : themeColors.text}>
//                 {vendor.contract_end_date ? new Date(vendor.contract_end_date).toLocaleDateString() : 'Not specified'}
//               </Typography>
//               {contractDaysLeft !== null && (
//                 <Typography fontSize={10} color={isExpiringSoon ? '#dc2626' : themeColors.muted}>
//                   {contractDaysLeft <= 0 ? 'Expired' : `${contractDaysLeft} days left`}
//                   {vendor.auto_renew && <Chip label="Auto-renew" size="small" sx={{ ml: 0.5, height: 15, fontSize: 8 }} />}
//                 </Typography>
//               )}
//             </Box>
//           </Box>
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={12} color={themeColors.muted}>Last Assessment</Typography>
//             <Typography fontSize={12} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.lastScan ? new Date(vendor.lastScan).toLocaleDateString() : 'Never'}
//             </Typography>
//           </Box>
//         </Stack>

//         <Divider sx={{ mb: 1.75, borderColor: themeColors.border }} />

//         <Typography fontSize={12} fontWeight={600} color={themeColors.text} sx={{ mb: 1 }}>Contact Information</Typography>
//         <Stack spacing={1} sx={{ mb: 2 }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={11} color={themeColors.muted}>Name</Typography>
//             <Typography fontSize={11} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.contact_name || 'Not specified'}
//             </Typography>
//           </Box>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={11} color={themeColors.muted}>Email</Typography>
//             <Typography fontSize={11} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.contact_email || 'Not specified'}
//             </Typography>
//           </Box>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//             <Typography fontSize={11} color={themeColors.muted}>Phone</Typography>
//             <Typography fontSize={11} fontWeight={500} color={themeColors.text} sx={{ textAlign: 'right' }}>
//               {vendor.contact_phone || 'Not specified'}
//             </Typography>
//           </Box>
//         </Stack>

//         <Divider sx={{ mb: 1.75, borderColor: themeColors.border }} />

//         <Typography fontSize={12} fontWeight={600} color={themeColors.text} sx={{ mb: 1 }}>Quick Actions</Typography>
//         <Stack spacing={0.25}>
//           {[
//             { icon: <Person sx={{ fontSize: 15 }} />, label: 'View Profile', onClick: () => onNavigate(vendor.id) },
//             { icon: <Assessment sx={{ fontSize: 15 }} />, label: 'View Assessments', onClick: () => {} },
//             { icon: <BugReport sx={{ fontSize: 15 }} />, label: 'View Issues', onClick: () => {} },
//             { icon: <Description sx={{ fontSize: 15 }} />, label: 'View Contracts', onClick: () => {} },
//             { icon: <PlayArrow sx={{ fontSize: 15 }} />, label: 'Start Assessment', onClick: () => {} },
//           ].map(({ icon, label, onClick }) => (
//             <Box
//               key={label}
//               onClick={onClick}
//               sx={{
//                 display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//                 px: 1, py: '7px', borderRadius: 1.5, cursor: 'pointer',
//                 '&:hover': { bgcolor: isDark ? '#1a1a1a' : '#f8fafc' }, transition: 'background 0.12s',
//               }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, color: themeColors.muted }}>
//                 {icon}
//                 <Typography fontSize={12} color={themeColors.text}>{label}</Typography>
//               </Box>
//               <ChevronRight sx={{ fontSize: 15, color: themeColors.muted }} />
//             </Box>
//           ))}
//         </Stack>
//       </Box>

//       <Box sx={{ p: 2, borderTop: `1px solid ${themeColors.border}`, flexShrink: 0 }}>
//         <Button
//           fullWidth variant="outlined"
//           onClick={() => onNavigate(vendor.id)}
//           sx={{
//             borderRadius: 1.5, textTransform: 'none', fontWeight: 600, py: 1, fontSize: 13,
//             borderColor: themeColors.border, color: themeColors.text,
//             '&:hover': { borderColor: '#3b82f6', color: '#3b82f6', bgcolor: '#eff6ff' },
//           }}
//         >
//           View Full Profile
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// const ROWS_PER_PAGE = 10;

// export default function Vendors() {
//   const navigate = useNavigate();
//   const [vendors, setVendors] = useState<Vendor[]>([]);
//   const [deletedVendors, setDeletedVendors] = useState<Vendor[]>([]);
//   const [search, setSearch] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [vendorToDelete, setVendorToDelete] = useState<Vendor | null>(null);
//   const [deleting, setDeleting] = useState(false);
//   const [deleteType, setDeleteType] = useState<'soft' | 'hard'>('soft');
//   const [activeTab, setActiveTab] = useState(0);
//   const [viewMode, setViewMode] = useState<'list' | 'grid'>('list');
//   const [page, setPage] = useState(1);
//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [panelVendor, setPanelVendor] = useState<Vendor | null>(null);

//   const [contractsExpiring, setContractsExpiring] = useState(0);
//   const [contractsTrend, setContractsTrend] = useState({ percentage: '0%', direction: 'flat' as 'up' | 'down' | 'flat' });
//   const [expiringContractsList, setExpiringContractsList] = useState<ExpiringContract[]>([]);

//   const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({ open: false, message: '', severity: 'success' });

//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [selectedVendor, setSelectedVendor] = useState<Vendor | null>(null);
  
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [editName, setEditName] = useState('');
//   const [editStatus, setEditStatus] = useState<'active' | 'cold'>('active');
//   const [editLifecycle, setEditLifecycle] = useState<'due_diligence' | 'active_monitoring' | 'offboarding'>('due_diligence');
//   const [editCategory, setEditCategory] = useState('');
//   const [editBusinessUnits, setEditBusinessUnits] = useState<string[]>([]);
//   const [editLocation, setEditLocation] = useState('');
//   const [editParentCompany, setEditParentCompany] = useState('');
//   const [editVendorSince, setEditVendorSince] = useState('');
//   const [editYtdSpend, setEditYtdSpend] = useState<number | null>(null);
//   const [editContactName, setEditContactName] = useState('');
//   const [editContactEmail, setEditContactEmail] = useState('');
//   const [editContactPhone, setEditContactPhone] = useState('');
//   const [editContractEndDate, setEditContractEndDate] = useState('');
//   const [editContractStartDate, setEditContractStartDate] = useState('');
//   const [editContractValue, setEditContractValue] = useState<number | null>(null);
//   const [editAutoRenew, setEditAutoRenew] = useState(false);
//   const [editRenewalNoticeDays, setEditRenewalNoticeDays] = useState(30);

//   // ─── Theme Colors ──────────────────────────────────────────────────────────
//   const muiTheme = useMuiTheme();
//   const { mode } = useCustomTheme();
//   const isDark = mode === 'dark';

//   // ─── PURE BLACK DARK THEME (matches reference screenshot) ─────────────────
//   const themeColors = {
//     text: isDark ? '#e2e8f0' : '#0f172a',
//     muted: isDark ? '#6b7280' : '#64748b',
//     background: isDark ? '#000000' : '#f8fafc',       // pure black page bg
//     cardBg: isDark ? '#0d0d0d' : '#ffffff',            // near-black cards
//     border: isDark ? '#1f1f1f' : '#e2e8f0',            // very dark borders
//     hover: isDark ? '#141414' : '#f8fafc',             // subtle hover
//     paper: isDark ? '#0d0d0d' : '#ffffff',             // dialogs / menus
//     inputBg: isDark ? '#0d0d0d' : '#ffffff',           // input backgrounds
//     tableHead: isDark ? '#0d0d0d' : '#f8fafc',         // table header bg
//     tableRow: isDark ? '#111111' : '#ffffff',          // table row bg
//     tableRowHover: isDark ? '#181818' : '#f8fafc',     // table row hover
//     tableRowSelected: isDark ? '#0f1e38' : '#eff6ff',  // selected row
//     panelSection: isDark ? '#1a1a1a' : '#f8fafc',      // panel inner sections
//     toggleSelected: isDark ? '#222222' : '#f1f5f9',    // toggle button selected
//   };

//   // ─── Effects ──────────────────────────────────────────────────────────────
//   useEffect(() => {
//     fetchVendors();
//     fetchDeletedVendors();
//     fetchExpiringContracts();
//   }, []);

//   const fetchVendors = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get('/v1/vendors');
//       const data = res.data.vendors ?? (Array.isArray(res.data) ? res.data : []);
//       setVendors(data.map((v: any) => ({
//         id: v.id, name: v.name, domain: v.domain,
//         score: v.score || v.overall_score || 0,
//         riskLevel: v.riskLevel || v.risk_level || 'Unknown',
//         lastScan: v.lastScan || v.last_scan,
//         createdAt: v.createdAt || v.created_at,
//         lifecycle: v.lifecycle || 'due_diligence',
//         status: v.status || 'active',
//         deletedAt: v.deletedAt || null,
//         category: v.category,
//         business_units: typeof v.business_units === 'string' ? JSON.parse(v.business_units) : (v.business_units || []),
//         location: v.location,
//         parent_company: v.parent_company,
//         vendor_since: v.vendor_since,
//         ytd_spend: v.ytd_spend,
//         contact_name: v.contact_name,
//         contact_email: v.contact_email,
//         contact_phone: v.contact_phone,
//         contract_end_date: v.contract_end_date,
//         contract_start_date: v.contract_start_date,
//         contract_value: v.contract_value,
//         auto_renew: v.auto_renew,
//         renewal_notice_days: v.renewal_notice_days || 30,
//       })));
//     } catch (e) { console.error('Error fetching vendors:', e); }
//     finally { setLoading(false); }
//   };

//   const fetchDeletedVendors = async () => {
//     try {
//       const res = await api.get('/v1/vendors/deleted');
//       if (res.data?.vendors) {
//         setDeletedVendors(res.data.vendors.map((v: any) => ({
//           id: v.id, name: v.name, domain: v.domain,
//           score: v.score || v.overall_score || 0,
//           riskLevel: v.riskLevel || v.risk_level || 'Unknown',
//           lastScan: v.lastScan || v.last_scan,
//           createdAt: v.createdAt || v.created_at,
//           deletedAt: v.deletedAt,
//           lifecycle: v.lifecycle || 'due_diligence',
//           status: v.status || 'active',
//           category: v.category,
//           business_units: typeof v.business_units === 'string' ? JSON.parse(v.business_units) : (v.business_units || []),
//         })));
//       }
//     } catch (e) { console.error(e); }
//   };

//   const fetchExpiringContracts = async () => {
//     try {
//       const res = await api.get('/v1/vendors/contracts/expiring?days_ahead=90');
//       setContractsExpiring(res.data.count);
//       setContractsTrend(res.data.trend || { percentage: '0%', direction: 'flat' });
//       setExpiringContractsList(res.data.expiring_contracts || []);
//     } catch {
//       setContractsExpiring(Math.floor(vendors.length * 0.026));
//       setContractsTrend({ percentage: '-18.6%', direction: 'down' });
//     }
//   };

//   const totalVendors = vendors.length;
//   const highRiskVendors = vendors.filter(v => v.riskLevel?.toLowerCase() === 'high').length;
//   const criticalVendors = vendors.filter(v => v.riskLevel?.toLowerCase() === 'critical').length;
//   const assessmentsDue = Math.floor(totalVendors * 0.07);

//   const getTabVendors = () => {
//     switch (activeTab) {
//       case 1: return vendors.filter(v => v.status === 'active');
//       case 2: return vendors.filter(v => v.riskLevel?.toLowerCase() === 'high');
//       case 3: return vendors.filter(v => v.riskLevel?.toLowerCase() === 'critical');
//       case 4: return vendors.filter(v => v.status === 'cold');
//       case 5: return deletedVendors;
//       default: return vendors;
//     }
//   };

//   const filteredVendors = getTabVendors().filter(v => {
//     const matchSearch = v.name?.toLowerCase().includes(search.toLowerCase()) || v.domain?.toLowerCase().includes(search.toLowerCase());
//     const matchCat = !selectedCategory || v.category === selectedCategory;
//     return matchSearch && matchCat;
//   });

//   const paginatedVendors = filteredVendors.slice((page - 1) * ROWS_PER_PAGE, page * ROWS_PER_PAGE);
//   const totalPages = Math.ceil(filteredVendors.length / ROWS_PER_PAGE);
//   const isTrashTab = activeTab === 5;

//   const TAB_LABELS = [
//     { label: 'All Vendors', count: vendors.length },
//     { label: 'Active', count: vendors.filter(v => v.status === 'active').length },
//     { label: 'High Risk', count: highRiskVendors },
//     { label: 'Critical', count: criticalVendors },
//     { label: 'Inactive', count: vendors.filter(v => v.status === 'cold').length },
//     { label: 'Archived', count: deletedVendors.length },
//   ];

//   // ─── Handlers ─────────────────────────────────────────────────────────────
//   const handleTabChange = (_: any, val: number) => {
//     setActiveTab(val); setPage(1); setSearch(''); setSelectedCategory('');
//     setPanelVendor(null);
//   };

//   const handleRowClick = (vendor: Vendor) =>
//     setPanelVendor(prev => prev?.id === vendor.id ? null : vendor);

//   const handleMenuOpen = (e: React.MouseEvent<HTMLElement>, vendor: Vendor) => {
//     e.stopPropagation();
//     setAnchorEl(e.currentTarget);
//     setSelectedVendor(vendor);
//     setEditName(vendor.name);
//     setEditStatus(vendor.status || 'active');
//     setEditLifecycle(vendor.lifecycle || 'due_diligence');
//     setEditCategory(vendor.category || '');
//     setEditBusinessUnits(vendor.business_units || []);
//     setEditLocation(vendor.location || '');
//     setEditParentCompany(vendor.parent_company || '');
//     setEditVendorSince(vendor.vendor_since || '');
//     setEditYtdSpend(vendor.ytd_spend || null);
//     setEditContactName(vendor.contact_name || '');
//     setEditContactEmail(vendor.contact_email || '');
//     setEditContactPhone(vendor.contact_phone || '');
//     setEditContractEndDate(vendor.contract_end_date || '');
//     setEditContractStartDate(vendor.contract_start_date || '');
//     setEditContractValue(vendor.contract_value || null);
//     setEditAutoRenew(vendor.auto_renew || false);
//     setEditRenewalNoticeDays(vendor.renewal_notice_days || 30);
//   };
  
//   const handleMenuClose = () => setAnchorEl(null);
//   const handleEditClick = () => { setEditDialogOpen(true); handleMenuClose(); };
//   const handleDialogClose = () => { setEditDialogOpen(false); setSelectedVendor(null); };

//   const handleSaveEdit = async () => {
//     if (!selectedVendor) return;
//     setSaving(true);
//     try {
//       await api.put(`/v1/vendors/${selectedVendor.id}`, {
//         name: editName,
//         domain: selectedVendor.domain,
//         lifecycle: editLifecycle,
//         status: editStatus,
//         category: editCategory,
//         business_units: editBusinessUnits,
//         location: editLocation,
//         parent_company: editParentCompany,
//         vendor_since: editVendorSince,
//         ytd_spend: editYtdSpend,
//         contact_name: editContactName,
//         contact_email: editContactEmail,
//         contact_phone: editContactPhone,
//         contract_end_date: editContractEndDate,
//         contract_start_date: editContractStartDate,
//         contract_value: editContractValue,
//         auto_renew: editAutoRenew,
//         renewal_notice_days: editRenewalNoticeDays,
//       });
//       await fetchVendors();
//       await fetchExpiringContracts();
//       setEditDialogOpen(false);
//       setSnackbar({ open: true, message: 'Vendor updated successfully', severity: 'success' });
//     } catch { 
//       setSnackbar({ open: true, message: 'Failed to update vendor', severity: 'error' }); 
//     }
//     finally { setSaving(false); }
//   };

//   const handleDeleteClick = (vendor: Vendor) => {
//     setVendorToDelete(vendor); setDeleteType('soft'); setDeleteDialogOpen(true); handleMenuClose();
//   };

//   const handleDeleteConfirm = async () => {
//     if (!vendorToDelete) return;
//     setDeleting(true);
//     try {
//       await api.delete(`/v1/vendors/${vendorToDelete.id}`, {
//         params: { permanent: deleteType === 'hard' }
//       });
//       await fetchVendors(); await fetchDeletedVendors(); await fetchExpiringContracts();
//       if (panelVendor?.id === vendorToDelete.id) setPanelVendor(null);
//       setSnackbar({ open: true, message: deleteType === 'hard' ? 'Vendor permanently deleted' : 'Vendor moved to trash', severity: 'success' });
//     } catch { setSnackbar({ open: true, message: 'Failed to delete vendor', severity: 'error' }); }
//     finally { setDeleting(false); setDeleteDialogOpen(false); setVendorToDelete(null); }
//   };

//   const handleRestoreVendor = async (vendor: Vendor) => {
//     try {
//       await api.post(`/v1/vendors/${vendor.id}/restore`);
//       setSnackbar({ open: true, message: `Vendor "${vendor.name}" restored`, severity: 'success' });
//       await fetchVendors(); await fetchDeletedVendors(); await fetchExpiringContracts();
//     } catch { setSnackbar({ open: true, message: 'Failed to restore vendor', severity: 'error' }); }
//   };

//   const handlePermanentDelete = async (vendor: Vendor) => {
//     if (!window.confirm(`⚠️ Permanently delete "${vendor.name}"? This cannot be undone.`)) return;
//     try {
//       await api.delete(`/v1/vendors/${vendor.id}/permanent`);
//       setSnackbar({ open: true, message: 'Vendor permanently deleted', severity: 'success' });
//       await fetchDeletedVendors(); await fetchExpiringContracts();
//     } catch { setSnackbar({ open: true, message: 'Failed to permanently delete vendor', severity: 'error' }); }
//   };

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   // ─── Shared input sx for dark theme ───────────────────────────────────────
//   const inputSx = {
//     '& .MuiOutlinedInput-root': {
//       color: themeColors.text,
//       bgcolor: themeColors.inputBg,
//       '& fieldset': { borderColor: themeColors.border },
//       '&:hover fieldset': { borderColor: isDark ? '#333333' : themeColors.muted },
//       '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
//     },
//     '& .MuiInputLabel-root': { color: themeColors.muted },
//     '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' },
//     '& .MuiSelect-icon': { color: themeColors.muted },
//   };

//   const selectSx = {
//     color: themeColors.text,
//     bgcolor: themeColors.inputBg,
//     '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.border },
//     '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: isDark ? '#333333' : themeColors.muted },
//     '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' },
//     '& .MuiSelect-icon': { color: themeColors.muted },
//   };

//   // ─── Render ──────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ 
//       p: 3, 
//       bgcolor: themeColors.background,
//       minHeight: '100vh' 
//     }}>
//       <Box sx={{ mb: 3 }}>
//         <Typography sx={{ fontWeight: 700, color: themeColors.text, fontSize: 20 }}>Vendors</Typography>
//         <Typography variant="body2" color={themeColors.muted}>Manage and monitor all your third-party vendors</Typography>
//       </Box>

//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         {[
//           { title: 'Total Vendors', value: totalVendors, trend: { percentage: '+6.3%', direction: 'up' as 'up' }, icon: <Business />, bgColor: isDark ? '#0a1628' : '#eff6ff', iconColor: '#3b82f6' },
//           { title: 'High Risk Vendors', value: highRiskVendors, trend: { percentage: '+8.7%', direction: 'up' as 'up' }, icon: <ErrorOutline />, bgColor: isDark ? '#1a0a0a' : '#fef2f2', iconColor: '#ef4444' },
//           { title: 'Critical Vendors', value: criticalVendors, trend: { percentage: '+12.4%', direction: 'up' as 'up' }, icon: <WarningIcon />, bgColor: isDark ? '#1a0a0a' : '#fef2f2', iconColor: '#dc2626' },
//           { title: 'Assessments Due', value: assessmentsDue, trend: { percentage: '-12.4%', direction: 'down' as 'down' }, icon: <Assessment />, bgColor: isDark ? '#1a1400' : '#fffbeb', iconColor: '#f59e0b' },
//           {
//             title: 'Contracts Expiring', value: contractsExpiring, trend: contractsTrend,
//             icon: <CalendarToday />, bgColor: isDark ? '#150a1f' : '#f3e8ff', iconColor: '#8b5cf6',
//             tooltip: expiringContractsList.length > 0 ? (
//               <Box sx={{ p: 0.5 }}>
//                 <Typography variant="caption" fontWeight={600} display="block" sx={{ mb: 0.5 }}>Expiring in 90 days:</Typography>
//                 {expiringContractsList.slice(0, 5).map(c => (
//                   <Typography key={c.id} variant="caption" display="block">• {c.name} ({c.days_left}d, notice: {c.notice_days}d)</Typography>
//                 ))}
//                 {expiringContractsList.length > 5 && (
//                   <Typography variant="caption" color="text.secondary">+{expiringContractsList.length - 5} more</Typography>
//                 )}
//               </Box>
//             ) : 'No contracts expiring soon',
//           },
//         ].map((card) => (
//           <Grid key={card.title} size={{ xs: 12, sm: 6, md: 2.4 }}>
//             <StatCard {...card} themeColors={themeColors} />
//           </Grid>
//         ))}
//       </Grid>

//       <Paper
//         sx={{
//           borderRadius: 2,
//           border: `1px solid ${themeColors.border}`,
//           boxShadow: 'none',
//           overflow: 'hidden',
//           display: 'flex',
//           flexDirection: 'row',
//           alignItems: 'stretch',
//           bgcolor: themeColors.cardBg,
//         }}
//       >
//         <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>

//           <Box sx={{ borderBottom: `1px solid ${themeColors.border}`, px: 2 }}>
//             <Tabs
//               value={activeTab}
//               onChange={handleTabChange}
//               variant="scrollable"
//               scrollButtons="auto"
//               sx={{
//                 '& .MuiTab-root': { 
//                   textTransform: 'none', fontWeight: 500, fontSize: 12, 
//                   color: themeColors.muted, minHeight: 44, px: 0, mr: 2.5 
//                 },
//                 '& .Mui-selected': { color: '#3b82f6 !important', fontWeight: 600 },
//                 '& .MuiTabs-indicator': { backgroundColor: '#3b82f6', height: 2 },
//                 '& .MuiTabs-scrollButtons': { color: themeColors.muted },
//               }}
//             >
//               {TAB_LABELS.map((tab, idx) => (
//                 <Tab
//                   key={idx}
//                   label={
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
//                       {tab.label}
//                       <Box sx={{
//                         bgcolor: activeTab === idx ? (isDark ? '#0f1e38' : '#eff6ff') : (isDark ? '#1a1a1a' : '#f1f5f9'),
//                         color: activeTab === idx ? '#3b82f6' : themeColors.muted,
//                         borderRadius: 10, px: 0.75, fontSize: 10, fontWeight: 600, lineHeight: '17px',
//                       }}>
//                         {tab.count}
//                       </Box>
//                     </Box>
//                   }
//                 />
//               ))}
//             </Tabs>
//           </Box>

//           <Box sx={{ 
//             px: 2, py: 1.25, display: 'flex', alignItems: 'center', 
//             justifyContent: 'space-between', gap: 1, 
//             borderBottom: `1px solid ${themeColors.border}`, 
//             flexWrap: 'wrap' 
//           }}>
//             <Typography fontSize={13} fontWeight={600} color={themeColors.text}>
//               {filteredVendors.length.toLocaleString()} Vendors
//             </Typography>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <TextField
//                 placeholder="Search vendors..."
//                 value={search}
//                 onChange={(e) => { setSearch(e.target.value); setPage(1); }}
//                 size="small"
//                 sx={{ 
//                   width: 180,
//                   ...inputSx,
//                   '& .MuiOutlinedInput-root': {
//                     ...inputSx['& .MuiOutlinedInput-root'],
//                     borderRadius: 1.5,
//                     fontSize: 12,
//                   },
//                 }}
//                 InputProps={{ 
//                   startAdornment: <InputAdornment position="start"><Search sx={{ fontSize: 15, color: themeColors.muted }} /></InputAdornment> 
//                 }}
//               />
//               <FormControl size="small" sx={{ minWidth: 130 }}>
//                 <Select
//                   displayEmpty 
//                   value={selectedCategory}
//                   onChange={(e) => { setSelectedCategory(e.target.value); setPage(1); }}
//                   renderValue={(v) => <Typography fontSize={12} color={v ? themeColors.text : themeColors.muted}>{v || 'All Categories'}</Typography>}
//                   sx={{ borderRadius: 1.5, fontSize: 12, ...selectSx }}
//                   MenuProps={{ PaperProps: { sx: { bgcolor: themeColors.paper, border: `1px solid ${themeColors.border}`, boxShadow: isDark ? '0 4px 20px rgba(0,0,0,0.8)' : '0 4px 16px rgba(0,0,0,0.1)' } } }}
//                 >
//                   <MenuItem value="" sx={{ fontSize: 12, color: themeColors.text }}>All Categories</MenuItem>
//                   {CATEGORY_OPTIONS.map(opt => (
//                     <MenuItem key={opt} value={opt} sx={{ fontSize: 12, color: themeColors.text }}>{opt}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//               <ToggleButtonGroup
//                 value={viewMode} exclusive
//                 onChange={(_, val) => val && setViewMode(val)}
//                 size="small"
//                 sx={{ 
//                   '& .MuiToggleButton-root': { 
//                     border: `1px solid ${themeColors.border}`, 
//                     borderRadius: '8px !important', 
//                     px: 0.75,
//                     color: themeColors.muted,
//                     bgcolor: themeColors.cardBg,
//                     '&.Mui-selected': { 
//                       bgcolor: themeColors.toggleSelected,
//                       color: themeColors.text,
//                       borderColor: themeColors.border,
//                     },
//                     '&:hover': { bgcolor: themeColors.hover },
//                   } 
//                 }}
//               >
//                 <ToggleButton value="list"><ViewList sx={{ fontSize: 17 }} /></ToggleButton>
//                 <ToggleButton value="grid"><GridView sx={{ fontSize: 17 }} /></ToggleButton>
//               </ToggleButtonGroup>
//             </Box>
//           </Box>

//           <TableContainer sx={{ overflowX: 'auto' }}>
//             <Table size="small" stickyHeader>
//               <TableHead>
//                 <TableRow>
//                   {['Vendor Name','Category','Risk Rating','Risk Score','Business Unit','Status','Last Assessment','Actions'].map((col, i) => (
//                     <TableCell
//                       key={col}
//                       align={i === 7 ? 'center' : 'left'}
//                       sx={{
//                         bgcolor: `${themeColors.tableHead} !important`,
//                         fontWeight: 600, fontSize: 11,
//                         color: themeColors.muted,
//                         py: 1.25, whiteSpace: 'nowrap',
//                         borderBottom: `1px solid ${themeColors.border}`,
//                       }}
//                     >
//                       {col}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {paginatedVendors.map((vendor) => {
//                   const riskColor = getRiskColor(vendor.riskLevel);
//                   const scoreColor = getScoreColor(vendor.score, vendor.riskLevel);
//                   const isPanelOpen = panelVendor?.id === vendor.id;

//                   return (
//                     <TableRow
//                       key={vendor.id}
//                       hover
//                       selected={isPanelOpen}
//                       onClick={() => !isTrashTab && handleRowClick(vendor)}
//                       sx={{
//                         cursor: isTrashTab ? 'default' : 'pointer',
//                         bgcolor: themeColors.tableRow,
//                         '&:hover td': { bgcolor: `${themeColors.tableRowHover} !important` },
//                         '&.Mui-selected td': { bgcolor: `${themeColors.tableRowSelected} !important` },
//                         '& td': {
//                           borderBottom: `1px solid ${themeColors.border}`,
//                           py: 0.75,
//                           bgcolor: 'inherit',
//                         },
//                       }}
//                     >
//                       <TableCell>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <Avatar
//                             src={`https://www.google.com/s2/favicons?domain=${vendor.domain}&sz=40`}
//                             sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: isDark ? '#1a1a1a' : '#f1f5f9' }}
//                             imgProps={{ onError: (e) => { (e.target as HTMLImageElement).style.display = 'none'; } }}
//                           >
//                             {vendor.name?.charAt(0).toUpperCase()}
//                           </Avatar>
//                           <Typography fontSize={12} fontWeight={600} color={themeColors.text} sx={{ whiteSpace: 'nowrap' }}>
//                             {vendor.name}
//                           </Typography>
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Typography fontSize={12} color={themeColors.muted}>{vendor.category || '—'}</Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Chip
//                           label={vendor.riskLevel || 'Unknown'} 
//                           size="small"
//                           sx={{
//                             bgcolor: riskColor + '25',
//                             color: riskColor,
//                             fontWeight: 600, 
//                             fontSize: 10, 
//                             height: 22, 
//                             borderRadius: 1,
//                             border: `1px solid ${riskColor}40`,
//                             '& .MuiChip-label': { color: riskColor, px: 1.5 }
//                           }}
//                         />
//                       </TableCell>
//                       <TableCell>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
//                           <Box sx={{ width: 38, bgcolor: themeColors.border, borderRadius: 1, height: 4 }}>
//                             <Box sx={{ width: `${vendor.score || 0}%`, bgcolor: scoreColor, borderRadius: 1, height: 4 }} />
//                           </Box>
//                           <Typography fontSize={11} fontWeight={700} sx={{ color: scoreColor, whiteSpace: 'nowrap' }}>
//                             {vendor.score || 0} / 100
//                           </Typography>
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Typography fontSize={12} color={themeColors.muted}>
//                           {vendor.business_units?.length ? vendor.business_units.join(', ') : '—'}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Chip
//                           label={vendor.status === 'active' ? 'Active' : 'Inactive'} 
//                           size="small"
//                           sx={{
//                             bgcolor: vendor.status === 'active' ? '#22c55e' : (isDark ? '#1a1a1a' : '#e2e8f0'),
//                             fontWeight: 600, fontSize: 10, height: 22, borderRadius: 1,
//                             color: '#ffffff',
//                             '& .MuiChip-label': {
//                               color: vendor.status === 'active' ? '#ffffff' : (isDark ? '#6b7280' : '#475569'),
//                               px: 1.5,
//                             }
//                           }}
//                         />
//                       </TableCell>
//                       <TableCell>
//                         <Typography fontSize={11} color={themeColors.muted} sx={{ whiteSpace: 'nowrap' }}>
//                           {vendor.lastScan ? new Date(vendor.lastScan).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Never'}
//                         </Typography>
//                       </TableCell>
//                       <TableCell align="center" onClick={(e) => e.stopPropagation()}>
//                         {isTrashTab ? (
//                           <>
//                             <Tooltip title="Restore">
//                               <IconButton size="small" onClick={() => handleRestoreVendor(vendor)} sx={{ color: '#10b981' }}>
//                                 <Restore sx={{ fontSize: 16 }} />
//                               </IconButton>
//                             </Tooltip>
//                             <Tooltip title="Permanent Delete">
//                               <IconButton size="small" onClick={() => handlePermanentDelete(vendor)} sx={{ color: '#dc2626' }}>
//                                 <DeleteSweep sx={{ fontSize: 16 }} />
//                               </IconButton>
//                             </Tooltip>
//                           </>
//                         ) : (
//                           <IconButton size="small" onClick={(e) => handleMenuOpen(e, vendor)}>
//                             <MoreVert sx={{ fontSize: 17, color: themeColors.muted }} />
//                           </IconButton>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })}

//                 {filteredVendors.length === 0 && (
//                   <TableRow sx={{ bgcolor: themeColors.tableRow }}>
//                     <TableCell colSpan={8} align="center" sx={{ py: 6, bgcolor: `${themeColors.tableRow} !important` }}>
//                       <Typography color={themeColors.muted} fontSize={13}>No vendors found.</Typography>
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           {filteredVendors.length > 0 && (
//             <Box sx={{ 
//               display: 'flex', alignItems: 'center', justifyContent: 'space-between', 
//               px: 2, py: 1.25, borderTop: `1px solid ${themeColors.border}`, 
//               flexWrap: 'wrap', gap: 1 
//             }}>
//               <Typography variant="caption" color={themeColors.muted}>
//                 Showing {(page - 1) * ROWS_PER_PAGE + 1} to {Math.min(page * ROWS_PER_PAGE, filteredVendors.length)} of {filteredVendors.length.toLocaleString()} vendors
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Pagination
//                   count={totalPages} page={page}
//                   onChange={(_, p) => setPage(p)}
//                   size="small" shape="rounded"
//                   sx={{
//                     '& .MuiPaginationItem-root': { 
//                       fontSize: 11, fontWeight: 500, minWidth: 26, height: 26,
//                       color: themeColors.muted,
//                       bgcolor: 'transparent',
//                       '&:hover': { bgcolor: themeColors.hover },
//                       '&.Mui-selected': { bgcolor: '#3b82f6 !important', color: '#fff' },
//                     },
//                   }}
//                 />
//                 <FormControl size="small">
//                   <Select 
//                     value={10} 
//                     sx={{ fontSize: 11, height: 26, borderRadius: 1, ...selectSx }}
//                     MenuProps={{ PaperProps: { sx: { bgcolor: themeColors.paper, border: `1px solid ${themeColors.border}` } } }}
//                   >
//                     <MenuItem value={10} sx={{ fontSize: 11, color: themeColors.text }}>10 / page</MenuItem>
//                     <MenuItem value={25} sx={{ fontSize: 11, color: themeColors.text }}>25 / page</MenuItem>
//                     <MenuItem value={50} sx={{ fontSize: 11, color: themeColors.text }}>50 / page</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Box>
//             </Box>
//           )}
//         </Box>

//         {panelVendor && (
//           <VendorDetailPanel
//             vendor={panelVendor}
//             onClose={() => setPanelVendor(null)}
//             onNavigate={(id: string) => navigate(`/vendors/${id}`)}
//             themeColors={themeColors}
//             isDark={isDark}
//           />
//         )}
//       </Paper>

//       {/* ─── Context Menu ─────────────────────────────────────────────────── */}
//       <Menu
//         anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//         transformOrigin={{ vertical: 'top', horizontal: 'right' }}
//         PaperProps={{ 
//           sx: { 
//             boxShadow: isDark ? '0 4px 20px rgba(0,0,0,0.8)' : '0 4px 16px rgba(0,0,0,0.1)', 
//             borderRadius: 2, 
//             border: `1px solid ${themeColors.border}`,
//             bgcolor: themeColors.paper,
//           } 
//         }}
//       >
//         <MenuItem onClick={handleEditClick} sx={{ fontSize: 13, color: themeColors.text, '&:hover': { bgcolor: themeColors.hover } }}>
//           <ListItemIcon><Edit fontSize="small" sx={{ color: themeColors.muted }} /></ListItemIcon>
//           <ListItemText>Edit Vendor</ListItemText>
//         </MenuItem>
//         <MenuItem onClick={() => selectedVendor && handleDeleteClick(selectedVendor)} sx={{ fontSize: 13, '&:hover': { bgcolor: themeColors.hover } }}>
//           <ListItemIcon><Delete fontSize="small" color="error" /></ListItemIcon>
//           <ListItemText sx={{ color: 'error.main' }}>Delete Vendor</ListItemText>
//         </MenuItem>
//       </Menu>

//       {/* ─── Edit Dialog ──────────────────────────────────────────────────── */}
//       <Dialog 
//         open={editDialogOpen} onClose={handleDialogClose} 
//         maxWidth="md" fullWidth 
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 2, 
//             maxHeight: '90vh',
//             bgcolor: themeColors.paper,
//             border: `1px solid ${themeColors.border}`,
//             boxShadow: isDark ? '0 8px 40px rgba(0,0,0,0.9)' : undefined,
//           } 
//         }}
//       >
//         <DialogTitle sx={{ fontWeight: 700, borderBottom: `1px solid ${themeColors.border}`, pb: 2, color: themeColors.text }}>
//           Edit Vendor
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3, pb: 1 }}>
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            
//             <Typography fontSize={13} fontWeight={700} color={themeColors.text} sx={{ borderBottom: `1px solid ${themeColors.border}`, pb: 0.5, mb: 1 }}>
//               Basic Information
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth label="Vendor Name" value={editName} onChange={(e) => setEditName(e.target.value)} size="small" sx={inputSx} />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel sx={{ color: themeColors.muted }}>Category</InputLabel>
//                   <Select value={editCategory} onChange={(e) => setEditCategory(e.target.value)} label="Category" sx={selectSx}
//                     MenuProps={{ PaperProps: { sx: { bgcolor: themeColors.paper, border: `1px solid ${themeColors.border}` } } }}>
//                     <MenuItem value="" sx={{ color: themeColors.text }}>None</MenuItem>
//                     {CATEGORY_OPTIONS.map(opt => <MenuItem key={opt} value={opt} sx={{ color: themeColors.text }}>{opt}</MenuItem>)}
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel sx={{ color: themeColors.muted }}>Business Units</InputLabel>
//                   <Select
//                     multiple value={editBusinessUnits}
//                     onChange={(e) => setEditBusinessUnits(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
//                     renderValue={(selected) => (
//                       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                         {(selected as string[]).map((value) => (
//                           <Chip key={value} label={value} size="small" sx={{ bgcolor: isDark ? '#1a1a1a' : undefined, color: themeColors.text }} />
//                         ))}
//                       </Box>
//                     )}
//                     label="Business Units" sx={selectSx}
//                     MenuProps={{ PaperProps: { sx: { bgcolor: themeColors.paper, border: `1px solid ${themeColors.border}` } } }}>
//                     {BUSINESS_UNIT_OPTIONS.map(opt => <MenuItem key={opt} value={opt} sx={{ color: themeColors.text }}>{opt}</MenuItem>)}
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel sx={{ color: themeColors.muted }}>Status</InputLabel>
//                   <Select value={editStatus} onChange={(e) => setEditStatus(e.target.value as 'active' | 'cold')} label="Status" sx={selectSx}
//                     MenuProps={{ PaperProps: { sx: { bgcolor: themeColors.paper, border: `1px solid ${themeColors.border}` } } }}>
//                     <MenuItem value="active" sx={{ color: themeColors.text }}>Active</MenuItem>
//                     <MenuItem value="cold" sx={{ color: themeColors.text }}>Inactive</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel sx={{ color: themeColors.muted }}>Lifecycle Stage</InputLabel>
//                   <Select value={editLifecycle} onChange={(e) => setEditLifecycle(e.target.value as any)} label="Lifecycle Stage" sx={selectSx}
//                     MenuProps={{ PaperProps: { sx: { bgcolor: themeColors.paper, border: `1px solid ${themeColors.border}` } } }}>
//                     {LIFECYCLE_OPTIONS.map(opt => (
//                       <MenuItem key={opt.value} value={opt.value} sx={{ color: themeColors.text }}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: opt.color }} />
//                           {opt.label}
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             <Typography fontSize={13} fontWeight={700} color={themeColors.text} sx={{ borderBottom: `1px solid ${themeColors.border}`, pb: 0.5, mb: 1, mt: 1 }}>
//               Company Details
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth label="Location" value={editLocation} onChange={(e) => setEditLocation(e.target.value)} size="small" placeholder="e.g., Austin, Texas" sx={inputSx} />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth label="Parent Company" value={editParentCompany} onChange={(e) => setEditParentCompany(e.target.value)} size="small" placeholder="e.g., CloudCore Holdings" sx={inputSx} />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth type="date" label="Vendor Since" value={editVendorSince} onChange={(e) => setEditVendorSince(e.target.value)} size="small" InputLabelProps={{ shrink: true }} sx={inputSx} />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth type="number" label="YTD Spend ($)" value={editYtdSpend || ''} onChange={(e) => setEditYtdSpend(e.target.value ? parseFloat(e.target.value) : null)} size="small"
//                   InputProps={{ startAdornment: <InputAdornment position="start"><Typography color={themeColors.muted}>$</Typography></InputAdornment> }} sx={inputSx} />
//               </Grid>
//             </Grid>

//             <Typography fontSize={13} fontWeight={700} color={themeColors.text} sx={{ borderBottom: `1px solid ${themeColors.border}`, pb: 0.5, mb: 1, mt: 1 }}>
//               Contract Details
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth type="date" label="Contract Start Date" value={editContractStartDate} onChange={(e) => setEditContractStartDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} sx={inputSx} />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth type="date" label="Contract End Date" value={editContractEndDate} onChange={(e) => setEditContractEndDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} sx={inputSx} />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth type="number" label="Contract Value ($)" value={editContractValue || ''} onChange={(e) => setEditContractValue(e.target.value ? parseFloat(e.target.value) : null)} size="small"
//                   InputProps={{ startAdornment: <InputAdornment position="start"><Typography color={themeColors.muted}>$</Typography></InputAdornment> }} sx={inputSx} />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel sx={{ color: themeColors.muted }}>Renewal Notice Period</InputLabel>
//                   <Select value={editRenewalNoticeDays} onChange={(e) => setEditRenewalNoticeDays(e.target.value as number)} label="Renewal Notice Period" sx={selectSx}
//                     MenuProps={{ PaperProps: { sx: { bgcolor: themeColors.paper, border: `1px solid ${themeColors.border}` } } }}>
//                     {[30, 60, 90, 120].map(d => <MenuItem key={d} value={d} sx={{ color: themeColors.text }}>{d} days before expiry</MenuItem>)}
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <FormControlLabel
//                   control={<Switch checked={editAutoRenew} onChange={(e) => setEditAutoRenew(e.target.checked)} color="primary" />}
//                   label={<Typography sx={{ color: themeColors.text, fontSize: 14 }}>Auto-renew Contract</Typography>}
//                 />
//               </Grid>
//             </Grid>

//             <Typography fontSize={13} fontWeight={700} color={themeColors.text} sx={{ borderBottom: `1px solid ${themeColors.border}`, pb: 0.5, mb: 1, mt: 1 }}>
//               Contact Information
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth label="Contact Name" value={editContactName} onChange={(e) => setEditContactName(e.target.value)} size="small" sx={inputSx} />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth type="email" label="Contact Email" value={editContactEmail} onChange={(e) => setEditContactEmail(e.target.value)} size="small" sx={inputSx} />
//               </Grid>
//               <Grid size={{ xs: 12, md: 6 }}>
//                 <TextField fullWidth label="Contact Phone" value={editContactPhone} onChange={(e) => setEditContactPhone(e.target.value)} size="small" sx={inputSx} />
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2, pt: 2, borderTop: `1px solid ${themeColors.border}` }}>
//           <Button onClick={handleDialogClose} sx={{ textTransform: 'none', color: themeColors.muted }}>Cancel</Button>
//           <Button onClick={handleSaveEdit} variant="contained" disabled={saving} sx={{ textTransform: 'none', borderRadius: 1.5, bgcolor: '#3b82f6', '&:hover': { bgcolor: '#2563eb' } }}>
//             {saving ? 'Saving...' : 'Save Changes'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* ─── Delete Dialog ────────────────────────────────────────────────── */}
//       <Dialog 
//         open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} 
//         maxWidth="sm" fullWidth 
//         PaperProps={{ sx: { borderRadius: 2, bgcolor: themeColors.paper, border: `1px solid ${themeColors.border}`, boxShadow: isDark ? '0 8px 40px rgba(0,0,0,0.9)' : undefined } }}
//       >
//         <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 700, color: themeColors.text }}>
//           <WarningIcon color="error" /> Delete Vendor
//         </DialogTitle>
//         <DialogContent>
//           <Typography sx={{ mb: 2, fontSize: 14, color: themeColors.text }}>
//             Are you sure you want to delete <strong>{vendorToDelete?.name}</strong>?
//           </Typography>
//           <FormControl fullWidth size="small">
//             <InputLabel sx={{ color: themeColors.muted }}>Delete Type</InputLabel>
//             <Select value={deleteType} onChange={(e) => setDeleteType(e.target.value as 'soft' | 'hard')} label="Delete Type" sx={selectSx}
//               MenuProps={{ PaperProps: { sx: { bgcolor: themeColors.paper, border: `1px solid ${themeColors.border}` } } }}>
//               <MenuItem value="soft" sx={{ color: themeColors.text }}>Soft Delete — Move to trash (restorable)</MenuItem>
//               <MenuItem value="hard" sx={{ color: themeColors.text }}>Hard Delete — Permanent (cannot be undone)</MenuItem>
//             </Select>
//           </FormControl>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={() => setDeleteDialogOpen(false)} sx={{ textTransform: 'none', color: themeColors.muted }}>Cancel</Button>
//           <Button onClick={handleDeleteConfirm} color="error" variant="contained" disabled={deleting} sx={{ textTransform: 'none', borderRadius: 1.5 }}>
//             {deleting ? 'Deleting...' : 'Delete'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* ─── FAB ──────────────────────────────────────────────────────────── */}
//       <Button
//         variant="contained"
//         startIcon={<Add />}
//         onClick={() => navigate('/vendors/add')}
//         sx={{
//           position: 'fixed', bottom: 24, right: 24,
//           borderRadius: 2,
//           boxShadow: '0 4px 12px rgba(59,130,246,0.4)',
//           textTransform: 'none', fontWeight: 600,
//           bgcolor: '#3b82f6', '&:hover': { bgcolor: '#2563eb' },
//         }}
//       >
//         Add Vendor
//       </Button>

//       {/* ─── Snackbar ─────────────────────────────────────────────────────── */}
//       {snackbar.open && (
//         <Box sx={{ position: 'fixed', bottom: 80, right: 24, zIndex: 1000 }}>
//           <Alert 
//             severity={snackbar.severity} 
//             onClose={() => setSnackbar({ ...snackbar, open: false })}
//             sx={{
//               bgcolor: themeColors.paper,
//               color: themeColors.text,
//               border: `1px solid ${themeColors.border}`,
//               '& .MuiAlert-icon': { color: snackbar.severity === 'success' ? '#10b981' : '#dc2626' },
//             }}
//           >
//             {snackbar.message}
//           </Alert>
//         </Box>
//       )}
//     </Box>
//   );
// }

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { teamQueries, vendorQueries, vendorRequestQueries } from '../../lib/queries';
import { useAuth } from '../../context/AuthContext';
import { useTheme as useCustomTheme } from '../../context/ThemeContext';
import { T, sans, card, th, td, topBtn, linkBtn } from './VendorDetails';
import type { VendorTab } from './VendorDetails';
import { VendorLogo } from '../VendorRequests/VendorRequests';
import ScanTypeButton, { ScanDepth } from '../../components/ScanTypeButton';
import { PII_RECORD_VOLUMES } from './AddVendor';

type Lifecycle = 'due_diligence' | 'active_monitoring' | 'offboarding';
type RiskBucket = 'critical' | 'high' | 'medium' | 'low' | 'unscanned';
type View = 'all' | 'attention' | 'high' | 'mine' | 'inactive' | 'archived' | 'requests';
type SortKey = 'name' | 'score' | 'risk' | 'lifecycle' | 'owner' | 'renewal' | 'lastScan';

interface Vendor {
  id: string;
  name: string;
  domain: string;
  score: number | null;
  riskLevel: string | null;
  lastScan: string | null;
  createdAt: string | null;
  deletedAt?: string | null;
  lifecycle: Lifecycle;
  status: 'active' | 'cold';
  category: string | null;
  business_units: string[];
  location: string | null;
  vendor_since: string | null;
  contract_end_date: string | null;
  renewal_notice_days: number | null;
  auto_renew: boolean;
  owner_user_id: string | null;
  owner_name: string | null;
  business_owner: string | null;
  data_sensitivity: string | null;
  pii_record_volume?: string | null;
  monitoring_paused: boolean;
  score_history: number[];
  previous_score: number | null;
}

interface OnboardingRequest {
  id: string;
  vendor_name: string;
  domain: string;
  requested_by_name: string | null;
  created_at: string;
  scan: { status: 'processing' | 'completed'; overall_score?: number; risk_level?: string } | null;
}

interface Reason { label: string; level: 'high' | 'medium' | 'low' }

const STALE_SCAN_DAYS = 30;
const RENEWAL_WINDOW_DAYS = 90;
const SCORE_DROP_ALERT = 5;
const PAGE_SIZES = [10, 25, 50];
const APP_HEADER_HEIGHT = 64;
const PANEL_SLIDE_MS = 220;

const LIFECYCLE: Record<Lifecycle, { label: string; color: string }> = {
  due_diligence: { label: 'Due diligence', color: '#f59e0b' },
  active_monitoring: { label: 'Active monitoring', color: '#10b981' },
  offboarding: { label: 'Offboarding', color: '#ef4444' },
};

const RISK: Record<RiskBucket, { label: string; color: string; rank: number }> = {
  critical: { label: 'Critical', color: '#B91C1C', rank: 0 },
  high: { label: 'High', color: '#EA580C', rank: 1 },
  medium: { label: 'Medium', color: '#D97706', rank: 2 },
  low: { label: 'Low', color: '#15803D', rank: 3 },
  unscanned: { label: 'Not scanned', color: '#94A3B8', rank: 4 },
};

const SENSITIVITY: Record<string, string> = {
  none: 'No sensitive data',
  internal: 'Internal data only',
  pii: 'Customer PII',
  financial: 'Financial or payment data',
  regulated: 'Regulated (health, financial, etc.)',
};

const DAY_MS = 86_400_000;
const daysSince = (iso: string | null) => (iso ? Math.floor((Date.now() - new Date(iso).getTime()) / DAY_MS) : null);
const daysUntil = (iso: string | null) => (iso ? Math.ceil((new Date(iso).getTime() - Date.now()) / DAY_MS) : null);
const fmtDate = (iso: string | null) =>
  iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';
const ago = (iso: string | null) => {
  const d = daysSince(iso);
  if (d === null) return 'Never';
  if (d <= 0) return 'Today';
  if (d === 1) return 'Yesterday';
  if (d < 60) return `${d} days ago`;
  const months = Math.floor(d / 30);
  return months === 1 ? '1 month ago' : `${months} months ago`;
};

const riskBucket = (v: Vendor): RiskBucket => {
  if (v.score === null || !v.lastScan) return 'unscanned';
  const level = (v.riskLevel || '').toLowerCase();
  if (level === 'critical') return 'critical';
  if (level === 'high') return 'high';
  if (level === 'medium') return 'medium';
  if (level === 'low' || level === 'very low') return 'low';
  return v.score >= 80 ? 'low' : v.score >= 60 ? 'medium' : 'high';
};

const scoreDelta = (v: Vendor) => (v.score !== null && v.previous_score !== null ? v.score - v.previous_score : null);

const attentionReasons = (v: Vendor): Reason[] => {
  const reasons: Reason[] = [];
  const bucket = riskBucket(v);
  if (bucket === 'critical' || bucket === 'high') reasons.push({ label: `${RISK[bucket].label} risk (${v.score}/100)`, level: 'high' });
  const delta = scoreDelta(v);
  if (delta !== null && delta <= -SCORE_DROP_ALERT) reasons.push({ label: `Score fell ${-delta} points on the last scan`, level: 'high' });
  const left = daysUntil(v.contract_end_date);
  if (left !== null && left < 0) reasons.push({ label: 'Contract has expired', level: 'high' });
  else if (left !== null && left <= (v.renewal_notice_days || 30)) reasons.push({ label: `Contract ends in ${left} day${left === 1 ? '' : 's'}`, level: 'medium' });
  const sinceScan = daysSince(v.lastScan);
  if (sinceScan === null) reasons.push({ label: 'Never scanned', level: 'medium' });
  else if (sinceScan > STALE_SCAN_DAYS) reasons.push({ label: `Last scanned ${sinceScan} days ago`, level: 'medium' });
  if (!v.owner_user_id) reasons.push({ label: 'No owner assigned', level: 'low' });
  if (!v.data_sensitivity) reasons.push({ label: 'Data sensitivity not classified', level: 'low' });
  return reasons;
};

const needsAttention = (v: Vendor) => v.status === 'active' && attentionReasons(v).some(r => r.level !== 'low');

const normalizeVendor = (v: any): Vendor => ({
  id: v.id,
  name: v.name,
  domain: v.domain,
  score: typeof v.score === 'number' ? v.score : null,
  riskLevel: v.riskLevel || v.risk_level || null,
  lastScan: v.lastScan || v.last_scan || null,
  createdAt: v.createdAt || v.created_at || null,
  deletedAt: v.deletedAt || v.deleted_at || null,
  lifecycle: (v.lifecycle in LIFECYCLE ? v.lifecycle : 'active_monitoring') as Lifecycle,
  status: String(v.status || 'active').toLowerCase() === 'cold' ? 'cold' : 'active',
  category: v.category || null,
  business_units: typeof v.business_units === 'string' ? JSON.parse(v.business_units || '[]') : (v.business_units || []),
  location: v.location || null,
  vendor_since: v.vendor_since || null,
  contract_end_date: v.contract_end_date || null,
  renewal_notice_days: v.renewal_notice_days ?? null,
  auto_renew: !!v.auto_renew,
  owner_user_id: v.owner_user_id || null,
  owner_name: v.owner_name || null,
  business_owner: v.business_owner || null,
  data_sensitivity: v.data_sensitivity || null,
  pii_record_volume: v.pii_record_volume || null,
  monitoring_paused: !!v.monitoring_paused,
  score_history: Array.isArray(v.score_history) ? v.score_history : [],
  previous_score: typeof v.previous_score === 'number' ? v.previous_score : null,
});

const EMPTY: never[] = [];
const selectVendors = (list: any[]) => list.map(normalizeVendor);
// Everything a vendor change can affect elsewhere in the app.
const VENDOR_DATA: string[][] = [['vendors'], ['dashboard'], ['reports'], ['monitoring']];

const csvCell = (value: unknown) => {
  let text = value === null || value === undefined ? '' : String(value);
  if (/^[=+\-@]/.test(text)) text = `'${text}`;
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const downloadCsv = (vendors: Vendor[]) => {
  const header = ['Vendor', 'Domain', 'Score', 'Previous score', 'Risk', 'Lifecycle', 'Status', 'Category',
    'Owner', 'Business owner', 'Data sensitivity', 'Contract end', 'Last scan'];
  const rows = vendors.map(v => [
    v.name, v.domain, v.score ?? '', v.previous_score ?? '', RISK[riskBucket(v)].label, LIFECYCLE[v.lifecycle].label,
    v.status === 'cold' ? 'Inactive' : 'Active', v.category ?? '', v.owner_name ?? '', v.business_owner ?? '',
    v.data_sensitivity ? SENSITIVITY[v.data_sensitivity] || v.data_sensitivity : '', v.contract_end_date ?? '',
    v.lastScan ? v.lastScan.slice(0, 10) : '',
  ]);
  const csv = [header, ...rows].map(r => r.map(csvCell).join(',')).join('\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = `vendors-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};

const apiError = (error: any, fallback: string) => {
  const d = error?.response?.data?.detail;
  return typeof d === 'string' ? d : (d && typeof d === 'object' && typeof d.message === 'string') ? d.message : fallback;
};

/* ─── Small pieces ─────────────────────────────────────────────────── */

function Sparkline({ points, width = 72, height = 22, isDark }: { points: number[]; width?: number; height?: number; isDark: boolean }) {
  if (points.length < 2) {
    return <span style={{ fontSize: 11, color: isDark ? '#64748b' : T.faint }}>—</span>;
  }
  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = max - min || 1;
  const step = width / (points.length - 1);
  const coords = points.map((p, i) => [i * step, height - 3 - ((p - min) / span) * (height - 6)]);
  const last = points[points.length - 1];
  const first = points[0];
  const color = last > first ? '#16A34A' : last < first ? '#DC2626' : (isDark ? '#94a3b8' : T.slate);
  const [lx, ly] = coords[coords.length - 1];
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block', overflow: 'visible' }}
      aria-label={`Score trend: ${points.join(', ')}`}>
      <polyline points={coords.map(c => c.join(',')).join(' ')} fill="none" stroke={color} strokeWidth={1.6} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={lx} cy={ly} r={2.4} fill={color} />
    </svg>
  );
}

function Delta({ value, isDark }: { value: number | null; isDark: boolean }) {
  if (value === null) return null;
  if (value === 0) return <span style={{ fontSize: 10.5, fontWeight: 600, color: isDark ? '#64748b' : T.muted, whiteSpace: 'nowrap' }}>±0</span>;
  const up = value > 0;
  return (
    <span style={{ fontSize: 10.5, fontWeight: 700, color: up ? '#16A34A' : '#DC2626', whiteSpace: 'nowrap' }}>
      {up ? '▲' : '▼'} {Math.abs(value)}
    </span>
  );
}

function Pill({ label, color, isDark, solid = false }: { label: string; color: string; isDark: boolean; solid?: boolean }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5, padding: '2px 8px', borderRadius: 99, fontSize: 11, fontWeight: 600,
      whiteSpace: 'nowrap', color: solid ? '#fff' : color, background: solid ? color : `${color}${isDark ? '26' : '14'}`,
      border: `1px solid ${color}${isDark ? '55' : '33'}`,
    }}>{label}</span>
  );
}

function Dot({ color }: { color: string }) {
  return <span style={{ width: 7, height: 7, borderRadius: '50%', background: color, flexShrink: 0, display: 'inline-block' }} />;
}

/* ─── Page ─────────────────────────────────────────────────────────── */

export default function Vendors() {
  const navigate = useNavigate();
  const location = useLocation();
  const { tenant, user } = useAuth();
  const { mode } = useCustomTheme();
  const isDark = mode === 'dark';

  const canEdit = !!user && user.role !== 'viewer';
  const isAdmin = !!user && (user.role === 'admin' || user.role === 'super_admin');

  const ink = isDark ? '#e2e8f0' : T.ink;
  const muted = isDark ? '#94a3b8' : T.muted;
  const slate = isDark ? '#94a3b8' : T.slate;
  const line = isDark ? '#1f1f1f' : T.bdr;
  const surface = isDark ? '#0d0d0d' : T.surface;
  const surface2 = isDark ? '#141414' : T.surface2;
  const bg = isDark ? '#000000' : T.bg;
  const accent = isDark ? '#3B82F6' : T.blue;
  const danger = isDark ? '#F87171' : T.red;

  const vendorsQuery = useQuery({ ...vendorQueries.list(), select: selectVendors });
  const archivedQuery = useQuery({ ...vendorQueries.archived(), select: selectVendors });
  const requestsQuery = useQuery(vendorRequestQueries.list('approved'));
  const teamQuery = useQuery(teamQueries.members());
  const vendors: Vendor[] = vendorsQuery.data ?? EMPTY;
  const archived: Vendor[] = archivedQuery.data ?? EMPTY;
  const requests: OnboardingRequest[] = requestsQuery.data ?? EMPTY;
  const teamMembers = teamQuery.data ?? EMPTY;
  const loading = vendorsQuery.isPending;
  const loadError = vendorsQuery.isError ? apiError(vendorsQuery.error, 'Could not load vendors. Try again.') : '';

  const updateMutation = useMutation({
    mutationFn: ({ v, changes }: { v: Vendor; changes: Record<string, unknown> }) =>
      api.put(`/v1/vendors/${v.id}`, { name: v.name, domain: v.domain, ...changes }),
    meta: { invalidates: VENDOR_DATA },
  });
  const deleteMutation = useMutation({
    mutationFn: ({ vendor, permanent }: { vendor: Vendor; permanent: boolean }) =>
      vendor.deletedAt ? api.delete(`/v1/vendors/${vendor.id}/permanent`) : api.delete(`/v1/vendors/${vendor.id}`, { params: { permanent } }),
    meta: { invalidates: VENDOR_DATA },
  });
  const restoreMutation = useMutation({
    mutationFn: (v: Vendor) => api.post(`/v1/vendors/${v.id}/restore`),
    meta: { invalidates: VENDOR_DATA },
  });
  const scanMutation = useMutation({
    mutationFn: async ({ v, depth }: { v: Vendor; depth: ScanDepth }) =>
      (await api.post(`/v1/vendors/${v.id}/trigger-scan`, null, { params: { scan_type: depth } })).data as { scan_id: string },
    meta: { invalidates: [['scans']] },
  });

  const [view, setView] = useState<View>(
    (location.state as { activeTab?: string } | null)?.activeTab === 'onboarding-requests' ? 'requests' : 'all'
  );
  const [search, setSearch] = useState('');
  const [riskFilter, setRiskFilter] = useState<RiskBucket | ''>('');
  const [lifecycleFilter, setLifecycleFilter] = useState<Lifecycle | ''>('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [ownerFilter, setOwnerFilter] = useState(() =>
    (location.state as { owner?: string } | null)?.owner ?? new URLSearchParams(location.search).get('owner') ?? '');
  const [sort, setSort] = useState<{ key: SortKey; dir: 'asc' | 'desc' }>({ key: 'risk', dir: 'asc' });
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const [panelId, setPanelId] = useState<string | null>(null);
  const [panelVisible, setPanelVisible] = useState(false);
  const panelTimer = useRef<number | undefined>(undefined);
  const [menu, setMenu] = useState<{ vendor: Vendor; top: number; left: number } | null>(null);
  const [renaming, setRenaming] = useState<Vendor | null>(null);
  const [renameValue, setRenameValue] = useState('');
  const [deleting, setDeleting] = useState<{ vendor: Vendor; permanent: boolean } | null>(null);
  const [busy, setBusy] = useState(false);
  const [dialogError, setDialogError] = useState('');
  const [bulkImporting, setBulkImporting] = useState(false);
  const [toast, setToast] = useState<{ message: string; tone: 'ok' | 'error'; link?: { label: string; to: string } } | null>(null);
  const toastTimer = useRef<number | undefined>(undefined);

  const showToast = (message: string, tone: 'ok' | 'error' = 'ok', link?: { label: string; to: string }) => {
    window.clearTimeout(toastTimer.current);
    setToast({ message, tone, link });
    toastTimer.current = window.setTimeout(() => setToast(null), 6000);
  };

  useEffect(() => () => { window.clearTimeout(toastTimer.current); window.clearTimeout(panelTimer.current); }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      if (menu) setMenu(null);
      else if (renaming || deleting) { if (!busy) { setRenaming(null); setDeleting(null); } }
      else if (panelId) closePanel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menu, renaming, deleting, busy, panelId]); // eslint-disable-line react-hooks/exhaustive-deps

  /* ─── Derived ─── */

  const maxVendors = tenant?.plan?.max_vendors;
  const limitReached = typeof maxVendors === 'number' && maxVendors !== -1 && vendors.length >= maxVendors;

  const scanned = vendors.filter(v => riskBucket(v) !== 'unscanned');
  const avgScore = scanned.length ? Math.round(scanned.reduce((sum, v) => sum + (v.score || 0), 0) / scanned.length) : null;
  const highOrCritical = vendors.filter(v => ['critical', 'high'].includes(riskBucket(v)));
  const overdue = vendors.filter(v => v.status === 'active' && (daysSince(v.lastScan) ?? Infinity) > STALE_SCAN_DAYS);
  const renewals = vendors
    .filter(v => { const d = daysUntil(v.contract_end_date); return d !== null && d >= 0 && d <= RENEWAL_WINDOW_DAYS; })
    .sort((a, b) => (daysUntil(a.contract_end_date) ?? 0) - (daysUntil(b.contract_end_date) ?? 0));
  const addedRecently = vendors.filter(v => (daysSince(v.createdAt) ?? Infinity) <= 30).length;
  const attention = vendors.filter(needsAttention);
  const mine = vendors.filter(v => user && v.owner_user_id === user.id);
  const inactive = vendors.filter(v => v.status === 'cold');
  const categories = useMemo(
    () => Array.from(new Set(vendors.map(v => v.category).filter(Boolean) as string[])).sort(),
    [vendors]
  );

  const views: { key: View; label: string; count: number; alert?: boolean }[] = [
    { key: 'all', label: 'All vendors', count: vendors.length },
    { key: 'attention', label: 'Needs attention', count: attention.length },
    { key: 'high', label: 'High risk', count: highOrCritical.length },
    { key: 'mine', label: 'My vendors', count: mine.length },
    { key: 'inactive', label: 'Inactive', count: inactive.length },
    { key: 'archived', label: 'Archived', count: archived.length },
    { key: 'requests', label: 'Onboarding requests', count: requests.length, alert: requests.length > 0 },
  ];

  const baseList = view === 'attention' ? attention
    : view === 'high' ? highOrCritical
    : view === 'mine' ? mine
    : view === 'inactive' ? inactive
    : view === 'archived' ? archived
    : vendors;

  const query = search.trim().toLowerCase();
  const filtered = baseList.filter(v =>
    (!query || [v.name, v.domain, v.category, v.owner_name, v.business_owner].some(f => f?.toLowerCase().includes(query))) &&
    (!riskFilter || riskBucket(v) === riskFilter) &&
    (!lifecycleFilter || v.lifecycle === lifecycleFilter) &&
    (!categoryFilter || v.category === categoryFilter) &&
    (!ownerFilter || (ownerFilter === 'unassigned' ? !v.owner_user_id : v.owner_user_id === ownerFilter))
  );

  const sorted = [...filtered].sort((a, b) => {
    const dir = sort.dir === 'asc' ? 1 : -1;
    const nullsLast = (x: number | string | null, y: number | string | null) => {
      if (x === null && y === null) return 0;
      if (x === null) return 1;
      if (y === null) return -1;
      return (x < y ? -1 : x > y ? 1 : 0) * dir;
    };
    switch (sort.key) {
      case 'name': return a.name.localeCompare(b.name) * dir;
      case 'score': return nullsLast(a.score, b.score);
      case 'risk': return (RISK[riskBucket(a)].rank - RISK[riskBucket(b)].rank) * dir || (a.score ?? 101) - (b.score ?? 101);
      case 'lifecycle': return LIFECYCLE[a.lifecycle].label.localeCompare(LIFECYCLE[b.lifecycle].label) * dir;
      case 'owner': return nullsLast(a.owner_name?.toLowerCase() ?? null, b.owner_name?.toLowerCase() ?? null);
      case 'renewal': return nullsLast(daysUntil(a.contract_end_date), daysUntil(b.contract_end_date));
      case 'lastScan': return nullsLast(daysSince(a.lastScan), daysSince(b.lastScan));
      default: return 0;
    }
  });

  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const pageRows = sorted.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  const filtersActive = !!(query || riskFilter || lifecycleFilter || categoryFilter || ownerFilter);
  const panelVendor = [...vendors, ...archived].find(v => v.id === panelId) || null;
  const selectedVendors = vendors.filter(v => selected.has(v.id));

  const resetPaging = () => { setPage(1); setSelected(new Set()); };
  const openPanel = (id: string) => {
    window.clearTimeout(panelTimer.current);
    setPanelId(id);
    setPanelVisible(true);
  };
  const closePanel = () => {
    setPanelVisible(false);
    window.clearTimeout(panelTimer.current);
    panelTimer.current = window.setTimeout(() => setPanelId(null), PANEL_SLIDE_MS);
  };
  const changeView = (next: View) => { setView(next); resetPaging(); if (panelId) closePanel(); };
  const clearFilters = () => { setSearch(''); setRiskFilter(''); setLifecycleFilter(''); setCategoryFilter(''); setOwnerFilter(''); resetPaging(); };
  const toggleSort = (key: SortKey) =>
    setSort(prev => (prev.key === key ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: key === 'score' ? 'desc' : 'asc' }));

  /* ─── Actions ─── */

  const openVendor = (v: Vendor, tab?: VendorTab) => navigate(`/vendors/${v.id}`, tab ? { state: { tab } } : undefined);

  const runScan = async (v: Vendor, depth: ScanDepth, quiet = false) => {
    try {
      const data = await scanMutation.mutateAsync({ v, depth });
      if (!quiet) showToast(`${depth === 'deep' ? 'Deep' : 'Fast'} scan started for ${v.name}.`, 'ok', { label: 'View progress', to: `/scans/${data.scan_id}/progress` });
      return true;
    } catch (error) {
      if (!quiet) showToast(apiError(error, `Could not start a scan for ${v.name}.`), 'error');
      return false;
    }
  };

  const runBulkScan = async (depth: ScanDepth) => {
    setBusy(true);
    const results = await Promise.all(selectedVendors.map(v => runScan(v, depth, true)));
    setBusy(false);
    const started = results.filter(Boolean).length;
    const failed = results.length - started;
    showToast(
      failed ? `Started ${started} ${depth} scan${started === 1 ? '' : 's'}; ${failed} could not start (already running or unavailable).`
             : `Started ${started} ${depth} scan${started === 1 ? '' : 's'}.`,
      failed && !started ? 'error' : 'ok'
    );
    setSelected(new Set());
  };

  // Bulk "Change owner": hands part of a portfolio to someone else (the Team page only offers "transfer all").
  const ownerMutation = useMutation({
    mutationFn: async (owner: string) => (await api.post('/v1/vendors/bulk-owner', {
      vendor_ids: selectedVendors.map(v => v.id), owner_user_id: owner || null,
    })).data as { updated: number; owner_name: string | null },
    meta: { invalidates: [['vendors'], ['users']] },
  });
  // The owner picked in the bulk bar, waiting for confirmation ('' = leave unassigned).
  const [pendingOwner, setPendingOwner] = useState<string | null>(null);
  const changeOwner = async (owner: string) => {
    try {
      const data = await ownerMutation.mutateAsync(owner);
      showToast(data.owner_name ? `${data.updated} vendor${data.updated === 1 ? '' : 's'} now owned by ${data.owner_name}.`
        : `${data.updated} vendor${data.updated === 1 ? '' : 's'} left unassigned.`);
      setSelected(new Set());
    } catch (error) {
      showToast(apiError(error, 'Could not change the owner.'), 'error');
    } finally {
      setPendingOwner(null);
    }
  };

  const updateVendor = async (v: Vendor, changes: Record<string, unknown>, message: string) => {
    await updateMutation.mutateAsync({ v, changes });
    showToast(message);
  };

  const toggleStatus = async (v: Vendor) => {
    const next = v.status === 'cold' ? 'active' : 'cold';
    try {
      await updateVendor(v, { status: next }, next === 'cold' ? `${v.name} marked inactive.` : `${v.name} marked active.`);
    } catch (error) {
      showToast(apiError(error, 'Could not update the vendor.'), 'error');
    }
  };

  const saveRename = async () => {
    if (!renaming) return;
    const name = renameValue.trim();
    if (!name) { setDialogError('Enter a name.'); return; }
    setBusy(true);
    setDialogError('');
    try {
      await updateVendor(renaming, { name }, `Renamed to ${name}.`);
      setRenaming(null);
    } catch (error) {
      setDialogError(apiError(error, 'Could not rename the vendor.'));
    } finally {
      setBusy(false);
    }
  };

  const confirmDelete = async () => {
    if (!deleting) return;
    const { vendor, permanent } = deleting;
    const isArchived = !!vendor.deletedAt;
    setBusy(true);
    setDialogError('');
    try {
      await deleteMutation.mutateAsync({ vendor, permanent });
      if (panelId === vendor.id) closePanel();
      setDeleting(null);
      showToast(permanent || isArchived ? `${vendor.name} was permanently deleted.` : `${vendor.name} moved to Archived.`);
    } catch (error) {
      setDialogError(apiError(error, 'Could not delete the vendor.'));
    } finally {
      setBusy(false);
    }
  };

  const restore = async (v: Vendor) => {
    try {
      await restoreMutation.mutateAsync(v);
      showToast(`${v.name} restored.`);
    } catch (error) {
      showToast(apiError(error, 'Could not restore the vendor.'), 'error');
    }
  };

  const openMenu = (e: React.MouseEvent, v: Vendor) => {
    e.stopPropagation();
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
    const menuHeight = 260;
    const top = rect.bottom + menuHeight > window.innerHeight ? rect.top - menuHeight : rect.bottom + 4;
    setMenu({ vendor: v, top: Math.max(8, top), left: Math.max(8, rect.right - 200) });
  };

  /* ─── Styles ─── */

  const inputStyle: React.CSSProperties = {
    padding: '7px 10px', fontSize: 12.5, fontFamily: sans, color: ink, background: surface,
    border: `1px solid ${line}`, borderRadius: 6, outline: 'none', boxSizing: 'border-box',
  };
  const selectStyle: React.CSSProperties = { ...inputStyle, paddingRight: 26, cursor: 'pointer' };
  const overlay: React.CSSProperties = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center',
    justifyContent: 'center', zIndex: 1300, padding: 16,
  };
  const dialog: React.CSSProperties = {
    width: '100%', maxWidth: 440, background: surface, border: `1px solid ${line}`, borderRadius: 10, padding: 20, fontFamily: sans,
  };
  const menuItem = (destructive = false): React.CSSProperties => ({
    display: 'block', width: '100%', textAlign: 'left', padding: '8px 12px', fontSize: 12.5, fontFamily: sans,
    background: 'none', border: 'none', cursor: 'pointer', color: destructive ? danger : ink, borderRadius: 5,
  });
  const sortHeader = (key: SortKey, label: string, align: 'left' | 'right' = 'left') => (
    <th style={{ ...th(isDark), textAlign: align, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
      onClick={() => toggleSort(key)} aria-sort={sort.key === key ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
      {label}
      <span style={{ marginLeft: 4, opacity: sort.key === key ? 1 : 0.3 }}>{sort.key === key && sort.dir === 'desc' ? '↓' : '↑'}</span>
    </th>
  );

  /* ─── Render ─── */

  if (loading) {
    return <div style={{ fontFamily: sans, background: bg, minHeight: '100vh', padding: 40, textAlign: 'center', color: muted, fontSize: 13 }}>Loading vendors…</div>;
  }

  const kpis = [
    {
      label: 'Vendors', value: vendors.length, color: ink,
      sub: addedRecently ? `+${addedRecently} added in the last 30 days` : `${inactive.length} inactive`,
      onClick: () => changeView('all'),
    },
    {
      label: 'Average score', value: avgScore ?? '—',
      color: avgScore === null ? muted : avgScore >= 80 ? T.grn : avgScore >= 60 ? T.amb : T.red,
      sub: `across ${scanned.length} scanned vendor${scanned.length === 1 ? '' : 's'}`,
      onClick: () => { changeView('all'); setSort({ key: 'score', dir: 'asc' }); },
    },
    {
      label: 'High & critical', value: highOrCritical.length, color: highOrCritical.length ? T.red : ink,
      sub: vendors.length ? `${Math.round((highOrCritical.length / vendors.length) * 100)}% of the portfolio` : 'no vendors yet',
      onClick: () => changeView('high'),
    },
    {
      label: 'Scans overdue', value: overdue.length, color: overdue.length ? T.amb : ink,
      sub: `not scanned in ${STALE_SCAN_DAYS} days`,
      onClick: () => { changeView('all'); setSort({ key: 'lastScan', dir: 'desc' }); },
    },
    {
      label: 'Renewals due', value: renewals.length, color: renewals.length ? '#7C3AED' : ink,
      sub: renewals[0] ? `next: ${renewals[0].name} in ${daysUntil(renewals[0].contract_end_date)} days` : `none in the next ${RENEWAL_WINDOW_DAYS} days`,
      onClick: () => { changeView('all'); setSort({ key: 'renewal', dir: 'asc' }); },
    },
  ];

  return (
    <div style={{ fontFamily: sans, background: bg, minHeight: '100vh' }}>
      {/* ── Header ── */}
      <div style={{
        padding: '16px 24px', borderBottom: `1px solid ${line}`, background: surface,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12,
      }}>
        <div>
          <h1 style={{ fontSize: 18, fontWeight: 700, color: ink, margin: 0 }}>Vendors</h1>
          <p style={{ fontSize: 12, color: muted, margin: '2px 0 0' }}>Every third party you monitor, its current risk, and what needs your attention.</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={{ ...topBtn(false, isDark), opacity: !sorted.length || view === 'requests' ? 0.5 : 1 }} onClick={() => downloadCsv(sorted)} disabled={!sorted.length || view === 'requests'}>Export CSV</button>
          {canEdit && (
            <button
              style={{ ...topBtn(false, isDark), opacity: limitReached ? 0.5 : 1, cursor: limitReached ? 'not-allowed' : 'pointer' }}
              onClick={() => !limitReached && setBulkImporting(true)}
              title={limitReached ? `Your plan allows ${maxVendors} vendors` : undefined}
              disabled={limitReached}
            >Bulk import</button>
          )}
          {canEdit && (
            <button
              style={{ ...topBtn(true, isDark), opacity: limitReached ? 0.5 : 1, cursor: limitReached ? 'not-allowed' : 'pointer' }}
              onClick={() => !limitReached && navigate('/vendors/add')}
              title={limitReached ? `Your plan allows ${maxVendors} vendors` : undefined}
              disabled={limitReached}
            >+ Add vendor</button>
          )}
        </div>
      </div>

      <div style={{ padding: '20px 24px', display: 'grid', gap: 16 }}>
        {limitReached && (
          <div role="status" style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
            padding: '10px 14px', borderRadius: 8, background: isDark ? '#2a1a05' : T.ambBg, border: `1px solid ${isDark ? '#78350f' : T.ambBdr}`,
            fontSize: 12.5, color: isDark ? '#FBBF24' : T.amb,
          }}>
            <span><strong>Vendor limit reached.</strong> Your plan allows {maxVendors} vendors. Archive one or upgrade to add more.</span>
            <button style={linkBtn(isDark)} onClick={() => navigate('/settings')}>View plan</button>
          </div>
        )}

        {loadError && (
          <div style={{ ...card(isDark), color: danger, fontSize: 12.5 }}>
            {loadError} <button style={linkBtn(isDark)} onClick={() => vendorsQuery.refetch()}>Retry</button>
          </div>
        )}

        {/* ── KPIs ── */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12 }}>
          {kpis.map(k => (
            <button key={k.label} onClick={k.onClick} style={{
              ...card(isDark), textAlign: 'left', cursor: 'pointer', fontFamily: sans, padding: '14px 16px',
            }}>
              <div style={{ fontSize: 10.5, fontWeight: 700, color: muted, textTransform: 'uppercase', letterSpacing: '.05em' }}>{k.label}</div>
              <div style={{ fontSize: 26, fontWeight: 700, color: k.color, marginTop: 6, lineHeight: 1 }}>{k.value}</div>
              <div style={{ fontSize: 11.5, color: muted, marginTop: 6, lineHeight: 1.35 }}>{k.sub}</div>
            </button>
          ))}
        </div>

        {/* ── Vendor list ── */}
        <div style={{ ...card(isDark), padding: 0, overflow: 'hidden' }}>
          <div style={{ display: 'flex', gap: 4, padding: '10px 12px', borderBottom: `1px solid ${line}`, overflowX: 'auto', scrollbarWidth: 'thin' }} role="tablist">
            {views.map(v => {
              const active = view === v.key;
              return (
                <button key={v.key} role="tab" aria-selected={active} onClick={() => changeView(v.key)} style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 11px', borderRadius: 99, border: 'none',
                  cursor: 'pointer', fontFamily: sans, fontSize: 12.5, fontWeight: 600, whiteSpace: 'nowrap',
                  background: active ? (isDark ? '#e2e8f0' : T.ink) : 'transparent', color: active ? (isDark ? '#0d0d0d' : '#fff') : slate,
                }}>
                  {v.label}
                  <span style={{
                    fontSize: 10.5, fontWeight: 700, padding: '0 6px', borderRadius: 99, lineHeight: '17px',
                    background: v.alert ? '#DC2626' : active ? (isDark ? '#0d0d0d22' : '#ffffff22') : surface2,
                    color: v.alert ? '#fff' : 'inherit',
                  }}>{v.count}</span>
                </button>
              );
            })}
          </div>

          {view === 'requests' ? (
            <OnboardingRequests requests={requests} canAdd={canEdit && !limitReached} isDark={isDark}
              onAdd={r => navigate('/vendors/add', { state: { requestId: r.id, name: r.vendor_name, domain: r.domain } })} />
          ) : (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px', borderBottom: `1px solid ${line}`, flexWrap: 'wrap' }}>
                <input
                  value={search} onChange={e => { setSearch(e.target.value); resetPaging(); }}
                  placeholder="Search vendors, domains, owners…" aria-label="Search vendors"
                  style={{ ...inputStyle, width: 240, maxWidth: '100%' }}
                />
                {view !== 'archived' && (
                  <>
                    <select aria-label="Risk" value={riskFilter} onChange={e => { setRiskFilter(e.target.value as RiskBucket | ''); resetPaging(); }} style={selectStyle}>
                      <option value="">All risk levels</option>
                      {(Object.keys(RISK) as RiskBucket[]).map(k => <option key={k} value={k}>{RISK[k].label}</option>)}
                    </select>
                    <select aria-label="Lifecycle" value={lifecycleFilter} onChange={e => { setLifecycleFilter(e.target.value as Lifecycle | ''); resetPaging(); }} style={selectStyle}>
                      <option value="">All stages</option>
                      {(Object.keys(LIFECYCLE) as Lifecycle[]).map(k => <option key={k} value={k}>{LIFECYCLE[k].label}</option>)}
                    </select>
                    {categories.length > 0 && (
                      <select aria-label="Category" value={categoryFilter} onChange={e => { setCategoryFilter(e.target.value); resetPaging(); }} style={selectStyle}>
                        <option value="">All categories</option>
                        {categories.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    )}
                    <select aria-label="Owner" value={ownerFilter} onChange={e => { setOwnerFilter(e.target.value); resetPaging(); }} style={selectStyle}>
                      <option value="">All owners</option>
                      <option value="unassigned">Unassigned</option>
                      {teamMembers.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                    </select>
                  </>
                )}
                {filtersActive && <button style={linkBtn(isDark)} onClick={clearFilters}>Clear filters</button>}
                <span style={{ marginLeft: 'auto', fontSize: 12, color: muted }}>
                  {sorted.length} {sorted.length === 1 ? 'vendor' : 'vendors'}
                </span>
              </div>

              {selected.size > 0 && (
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 12, padding: '8px 12px', borderBottom: `1px solid ${line}`,
                  background: isDark ? '#0a1628' : T.blueBg, fontSize: 12.5, color: ink, flexWrap: 'wrap',
                }}>
                  <strong>{selected.size} selected</strong>
                  {canEdit && <ScanTypeButton label="Run scan" busy={busy} busyLabel="Starting scans…" onPick={runBulkScan} isDark={isDark} align="left" buttonStyle={linkBtn(isDark)} />}
                  {canEdit && (
                    <select aria-label="Change owner of the selected vendors" value="" disabled={ownerMutation.isPending}
                      onChange={e => { if (e.target.value) setPendingOwner(e.target.value === '__none' ? '' : e.target.value); }}
                      style={{ fontSize: 12.5, fontFamily: sans, color: isDark ? '#3B82F6' : T.blue, fontWeight: 600, background: 'transparent',
                        border: 'none', cursor: 'pointer', padding: 0 }}>
                      <option value="">{ownerMutation.isPending ? 'Changing owner…' : 'Change owner…'}</option>
                      {teamMembers.map((m: any) => <option key={m.id} value={m.id}>{m.name || m.email}</option>)}
                      <option value="__none">Leave unassigned</option>
                    </select>
                  )}
                  <button style={linkBtn(isDark)} onClick={() => downloadCsv(selectedVendors)}>Export CSV</button>
                  <button style={{ ...linkBtn(isDark), color: muted }} onClick={() => setSelected(new Set())}>Clear selection</button>
                </div>
              )}

              {/* The list scrolls inside the card (header row stays pinned) instead of stretching the page. */}
              <style>{'.vendor-table-scroll thead th { position: sticky; top: 0; z-index: 1; }'}</style>
              <div className="vendor-table-scroll" style={{ overflow: 'auto', maxHeight: 'calc(100vh - 330px)', minHeight: 240 }}>
                {view === 'archived' ? (
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={th(isDark)}>Vendor</th>
                        <th style={th(isDark)}>Last score</th>
                        <th style={th(isDark)}>Archived</th>
                        <th style={{ ...th(isDark), textAlign: 'right' }} />
                      </tr>
                    </thead>
                    <tbody>
                      {pageRows.map(v => (
                        <tr key={v.id}>
                          <td style={td(isDark)}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                              <VendorLogo name={v.name} domain={v.domain} size={28} isDark={isDark} />
                              <div><div style={{ fontWeight: 600 }}>{v.name}</div><div style={{ fontSize: 11, color: muted }}>{v.domain}</div></div>
                            </div>
                          </td>
                          <td style={td(isDark)}>{v.score ?? '—'}</td>
                          <td style={{ ...td(isDark), color: muted }}>{fmtDate(v.deletedAt || null)}</td>
                          <td style={{ ...td(isDark), textAlign: 'right', whiteSpace: 'nowrap' }}>
                            {canEdit && <button style={linkBtn(isDark)} onClick={() => restore(v)}>Restore</button>}
                            {isAdmin && (
                              <button style={{ ...linkBtn(isDark), color: danger, marginLeft: 12 }}
                                onClick={() => { setDialogError(''); setDeleting({ vendor: v, permanent: true }); }}>Delete permanently</button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
                    <thead>
                      <tr>
                        <th style={{ ...th(isDark), width: 34 }}>
                          <input type="checkbox" aria-label="Select all on this page"
                            checked={pageRows.length > 0 && pageRows.every(v => selected.has(v.id))}
                            onChange={e => setSelected(prev => {
                              const next = new Set(prev);
                              pageRows.forEach(v => { if (e.target.checked) next.add(v.id); else next.delete(v.id); });
                              return next;
                            })} />
                        </th>
                        {sortHeader('name', 'Vendor')}
                        {sortHeader('score', 'Score')}
                        {sortHeader('risk', 'Risk')}
                        {sortHeader('lifecycle', 'Lifecycle')}
                        {sortHeader('owner', 'Owner')}
                        {sortHeader('renewal', 'Renewal')}
                        {sortHeader('lastScan', 'Last scan')}
                        <th style={{ ...th(isDark), width: 40 }} />
                      </tr>
                    </thead>
                    <tbody>
                      {pageRows.map(v => {
                        const bucket = riskBucket(v);
                        const left = daysUntil(v.contract_end_date);
                        const sinceScan = daysSince(v.lastScan);
                        const stale = sinceScan === null || sinceScan > STALE_SCAN_DAYS;
                        const flagged = needsAttention(v);
                        const isOpen = panelId === v.id;
                        return (
                          <tr key={v.id} data-vendor-row onClick={() => (isOpen ? closePanel() : openPanel(v.id))}
                            style={{ cursor: 'pointer', background: isOpen ? (isDark ? '#0f1e38' : T.blueBg) : selected.has(v.id) ? surface2 : 'transparent' }}
                            onMouseEnter={e => { if (!isOpen) e.currentTarget.style.background = surface2; }}
                            onMouseLeave={e => { if (!isOpen) e.currentTarget.style.background = selected.has(v.id) ? surface2 : 'transparent'; }}>
                            <td style={td(isDark)} onClick={e => e.stopPropagation()}>
                              <input type="checkbox" aria-label={`Select ${v.name}`} checked={selected.has(v.id)}
                                onChange={e => setSelected(prev => { const next = new Set(prev); if (e.target.checked) next.add(v.id); else next.delete(v.id); return next; })} />
                            </td>
                            <td style={td(isDark)}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 200 }}>
                                <VendorLogo name={v.name} domain={v.domain} size={30} isDark={isDark} />
                                <div style={{ minWidth: 0 }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ fontWeight: 600, fontSize: 13 }}>{v.name}</span>
                                    {flagged && <span title="Needs attention" style={{ width: 6, height: 6, borderRadius: '50%', background: '#DC2626' }} />}
                                    {v.status === 'cold' && <Pill label="Inactive" color={T.slate} isDark={isDark} />}
                                    {v.monitoring_paused && <Pill label="Paused" color={T.slate} isDark={isDark} />}
                                  </div>
                                  <div style={{ fontSize: 11, color: muted }}>{v.domain}{v.category ? ` · ${v.category}` : ''}</div>
                                </div>
                              </div>
                            </td>
                            <td style={td(isDark)}>
                              {v.score === null || bucket === 'unscanned' ? <span style={{ color: muted }}>—</span> : (
                                <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                                  <span style={{ fontSize: 15, fontWeight: 700, color: RISK[bucket].color }}>{v.score}</span>
                                  <Delta value={scoreDelta(v)} isDark={isDark} />
                                </div>
                              )}
                            </td>
                            <td style={td(isDark)}><Pill label={RISK[bucket].label} color={RISK[bucket].color} isDark={isDark} /></td>
                            <td style={td(isDark)}>
                              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
                                <Dot color={LIFECYCLE[v.lifecycle].color} />{LIFECYCLE[v.lifecycle].label}
                              </span>
                            </td>
                            <td style={{ ...td(isDark), color: v.owner_name ? ink : muted, whiteSpace: 'nowrap' }}>{v.owner_name || 'Unassigned'}</td>
                            <td style={{ ...td(isDark), whiteSpace: 'nowrap' }}>
                              {left === null ? <span style={{ color: muted }}>—</span> : (
                                <>
                                  <div>{fmtDate(v.contract_end_date)}</div>
                                  <div style={{ fontSize: 11, color: left < 0 ? danger : left <= (v.renewal_notice_days || 30) ? (isDark ? '#FBBF24' : T.amb) : muted }}>
                                    {left < 0 ? 'Expired' : `${left} days left`}{v.auto_renew ? ' · auto-renews' : ''}
                                  </div>
                                </>
                              )}
                            </td>
                            <td style={{ ...td(isDark), whiteSpace: 'nowrap', color: stale ? (isDark ? '#FBBF24' : T.amb) : ink }}>{ago(v.lastScan)}</td>
                            <td style={{ ...td(isDark), textAlign: 'right' }}>
                              <button aria-label={`Actions for ${v.name}`} onClick={e => openMenu(e, v)} style={{
                                background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: muted, padding: '2px 6px', borderRadius: 4, lineHeight: 1,
                              }}>⋯</button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}

                {sorted.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '44px 16px' }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: ink }}>
                      {filtersActive ? 'No vendors match these filters'
                        : view === 'archived' ? 'Nothing archived'
                        : view === 'attention' ? 'Nothing needs attention'
                        : view === 'mine' ? 'You don\'t own any vendors yet'
                        : view === 'inactive' ? 'No inactive vendors'
                        : view === 'high' ? 'No high or critical risk vendors'
                        : 'No vendors yet'}
                    </div>
                    <div style={{ fontSize: 12.5, color: muted, marginTop: 4 }}>
                      {filtersActive ? <button style={linkBtn(isDark)} onClick={clearFilters}>Clear filters</button>
                        : view === 'mine' ? 'Assign yourself as owner on a vendor\'s Profile tab.'
                        : view === 'all' && canEdit ? 'Add your first vendor to start monitoring it.' : null}
                    </div>
                  </div>
                )}
              </div>

              {sorted.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '10px 12px', borderTop: `1px solid ${line}`, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 12, color: muted }}>
                    Showing {(currentPage - 1) * pageSize + 1}–{Math.min(currentPage * pageSize, sorted.length)} of {sorted.length}
                  </span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <button style={{ ...topBtn(false, isDark), opacity: currentPage <= 1 ? 0.45 : 1 }} disabled={currentPage <= 1} onClick={() => setPage(currentPage - 1)}>‹ Prev</button>
                    <span style={{ fontSize: 12, color: muted, padding: '0 4px' }}>Page {currentPage} of {totalPages}</span>
                    <button style={{ ...topBtn(false, isDark), opacity: currentPage >= totalPages ? 0.45 : 1 }} disabled={currentPage >= totalPages} onClick={() => setPage(currentPage + 1)}>Next ›</button>
                    <select aria-label="Rows per page" value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }} style={selectStyle}>
                      {PAGE_SIZES.map(n => <option key={n} value={n}>{n} / page</option>)}
                    </select>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* ── Row menu ── */}
      {menu && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1250 }} onClick={() => setMenu(null)}>
          <div role="menu" onClick={e => e.stopPropagation()} style={{
            position: 'fixed', top: menu.top, left: menu.left, width: 200, padding: 4, background: surface,
            border: `1px solid ${line}`, borderRadius: 8, boxShadow: isDark ? '0 8px 30px rgba(0,0,0,.8)' : '0 8px 24px rgba(15,23,42,.12)',
          }}>
            <button role="menuitem" style={menuItem()} onClick={() => { setMenu(null); openVendor(menu.vendor); }}>Open vendor</button>
            {canEdit && <>
              <button role="menuitem" style={menuItem()} onClick={() => { setMenu(null); openVendor(menu.vendor, 'profile'); }}>Edit profile</button>
              <button role="menuitem" style={menuItem()} onClick={() => { setMenu(null); runScan(menu.vendor, 'fast'); }}>Fast scan</button>
              <button role="menuitem" style={menuItem()} onClick={() => { setMenu(null); runScan(menu.vendor, 'deep'); }}>Deep scan</button>
              <button role="menuitem" style={menuItem()} onClick={() => { setMenu(null); setDialogError(''); setRenameValue(menu.vendor.name); setRenaming(menu.vendor); }}>Rename</button>
              <button role="menuitem" style={menuItem()} onClick={() => { setMenu(null); toggleStatus(menu.vendor); }}>
                {menu.vendor.status === 'cold' ? 'Mark as active' : 'Mark as inactive'}
              </button>
            </>}
            {isAdmin && <>
              <div style={{ height: 1, background: line, margin: '4px 0' }} />
              <button role="menuitem" style={menuItem(true)} onClick={() => { setMenu(null); setDialogError(''); setDeleting({ vendor: menu.vendor, permanent: false }); }}>Archive</button>
              <button role="menuitem" style={menuItem(true)} onClick={() => { setMenu(null); setDialogError(''); setDeleting({ vendor: menu.vendor, permanent: true }); }}>Delete permanently</button>
            </>}
          </div>
        </div>
      )}

      {/* ── Side panel ── */}
      {panelVendor && (
        <VendorPanel vendor={panelVendor} isDark={isDark} canEdit={canEdit} canDelete={isAdmin}
          visible={panelVisible} onClose={closePanel} onOpen={() => openVendor(panelVendor)} onScan={depth => runScan(panelVendor, depth)}
          onDelete={() => { setDialogError(''); setDeleting({ vendor: panelVendor, permanent: false }); }} />
      )}

      {/* ── Confirm bulk owner change ── */}
      {pendingOwner !== null && (() => {
        const toName = (teamMembers as any[]).find(m => m.id === pendingOwner)?.name || null;
        const n = selectedVendors.length;
        const moving = ownerMutation.isPending;
        return (
          <div style={overlay} onMouseDown={e => { if (e.target === e.currentTarget && !moving) setPendingOwner(null); }}>
            <div style={dialog} role="alertdialog" aria-modal="true" aria-label="Confirm owner change">
              <div style={{ fontSize: 15, fontWeight: 700, color: ink, marginBottom: 8 }}>
                {toName ? `Change the owner of ${n} vendor${n === 1 ? '' : 's'} to ${toName}?` : `Leave ${n} vendor${n === 1 ? '' : 's'} unassigned?`}
              </div>
              <div style={{ fontSize: 13, color: muted, lineHeight: 1.55 }}>
                {toName ? <>{toName} becomes the accountable owner, replacing whoever owns {n === 1 ? 'it' : 'them'} now.</>
                  : <>{n === 1 ? 'It' : 'They'} will have no owner until you assign one.</>}
              </div>
              <div style={{ marginTop: 12, padding: '8px 12px', borderRadius: 8, border: `1px solid ${line}`, fontSize: 13, color: ink, lineHeight: 1.7 }}>
                {selectedVendors.slice(0, 5).map(v => <div key={v.id}>{v.name}{v.owner_name ? <span style={{ color: muted }}> · now {v.owner_name}</span> : null}</div>)}
                {n > 5 && <div style={{ color: muted }}>and {n - 5} more</div>}
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                <button autoFocus type="button" style={topBtn(false, isDark)} onClick={() => setPendingOwner(null)} disabled={moving}>Cancel</button>
                <button type="button" style={{ ...topBtn(true, isDark), opacity: moving ? 0.7 : 1 }} disabled={moving} onClick={() => changeOwner(pendingOwner)}>
                  {moving ? 'Changing…' : toName ? 'Change owner' : 'Unassign'}
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Rename ── */}
      {renaming && (
        <div style={overlay} onMouseDown={e => { if (e.target === e.currentTarget && !busy) setRenaming(null); }}>
          <form style={dialog} role="dialog" aria-modal="true" aria-label="Rename vendor" onSubmit={e => { e.preventDefault(); if (!busy) saveRename(); }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: ink, marginBottom: 12 }}>Rename vendor</div>
            <input autoFocus value={renameValue} maxLength={200} onChange={e => setRenameValue(e.target.value)} style={{ ...inputStyle, width: '100%' }} />
            {dialogError && <div role="alert" style={{ fontSize: 12, color: danger, marginTop: 10 }}>{dialogError}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
              <button type="button" style={topBtn(false, isDark)} onClick={() => setRenaming(null)} disabled={busy}>Cancel</button>
              <button type="submit" style={{ ...topBtn(true, isDark), opacity: busy ? 0.7 : 1 }} disabled={busy}>{busy ? 'Saving…' : 'Save'}</button>
            </div>
          </form>
        </div>
      )}

      {/* ── Bulk import ── */}
      {bulkImporting && (
        <BulkImportModal
          isDark={isDark}
          onClose={() => setBulkImporting(false)}
          onDone={created => {
            setBulkImporting(false);
            if (created > 0) { showToast(`${created} vendor${created === 1 ? '' : 's'} imported.`); vendorsQuery.refetch(); }
          }}
        />
      )}

      {/* ── Archive / delete ── */}
      {deleting && (
        <div style={overlay} onMouseDown={e => { if (e.target === e.currentTarget && !busy) setDeleting(null); }}>
          <div style={dialog} role="dialog" aria-modal="true" aria-label="Delete vendor">
            <div style={{ fontSize: 15, fontWeight: 700, color: ink, marginBottom: 8 }}>
              {deleting.permanent || deleting.vendor.deletedAt ? 'Delete permanently' : 'Archive vendor'}
            </div>
            <div style={{ fontSize: 13, color: muted, lineHeight: 1.55 }}>
              {deleting.permanent || deleting.vendor.deletedAt ? (
                <>Permanently delete <strong style={{ color: ink }}>{deleting.vendor.name}</strong> with its scan history, contacts and fourth parties? This can't be undone.</>
              ) : (
                <>Move <strong style={{ color: ink }}>{deleting.vendor.name}</strong> to Archived? It stops counting toward your portfolio and can be restored any time.</>
              )}
            </div>
            {!deleting.vendor.deletedAt && (
              <div role="radiogroup" aria-label="How to delete" style={{ display: 'grid', gap: 8, marginTop: 14 }}>
                {[
                  { permanent: false, title: 'Archive', hint: 'Hidden from the portfolio, restorable from Archived.' },
                  { permanent: true, title: 'Delete permanently', hint: 'Removes the vendor and all its data. Cannot be undone.' },
                ].map(option => {
                  const chosen = deleting.permanent === option.permanent;
                  return (
                    <label key={option.title} style={{
                      display: 'flex', gap: 10, alignItems: 'flex-start', padding: '10px 12px', borderRadius: 8, cursor: 'pointer',
                      border: `1px solid ${chosen ? (option.permanent ? '#DC2626' : accent) : line}`,
                      background: chosen ? (option.permanent ? (isDark ? '#1a0a0a' : T.redBg) : (isDark ? '#0a1628' : T.blueBg)) : 'transparent',
                    }}>
                      <input type="radio" name="delete-mode" checked={chosen} disabled={busy}
                        onChange={() => setDeleting({ vendor: deleting.vendor, permanent: option.permanent })} style={{ marginTop: 2 }} />
                      <span>
                        <span style={{ display: 'block', fontSize: 13, fontWeight: 600, color: ink }}>{option.title}</span>
                        <span style={{ display: 'block', fontSize: 11.5, color: muted, marginTop: 2 }}>{option.hint}</span>
                      </span>
                    </label>
                  );
                })}
              </div>
            )}
            {dialogError && <div role="alert" style={{ fontSize: 12, color: danger, marginTop: 10 }}>{dialogError}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 18 }}>
              <button style={topBtn(false, isDark)} onClick={() => setDeleting(null)} disabled={busy}>Cancel</button>
              <button style={{ ...topBtn(true, isDark), background: '#DC2626', opacity: busy ? 0.7 : 1 }} onClick={confirmDelete} disabled={busy}>
                {busy ? 'Working…' : deleting.permanent || deleting.vendor.deletedAt ? 'Delete permanently' : 'Archive'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Toast ── */}
      {toast && (
        <div role="status" style={{
          position: 'fixed', bottom: 20, right: 20, zIndex: 1400, maxWidth: 380, display: 'flex', alignItems: 'center', gap: 12,
          padding: '10px 14px', borderRadius: 8, fontSize: 12.5, fontFamily: sans, background: surface, color: ink,
          border: `1px solid ${toast.tone === 'error' ? danger : line}`, boxShadow: isDark ? '0 8px 30px rgba(0,0,0,.8)' : '0 8px 24px rgba(15,23,42,.12)',
        }}>
          <span style={{ color: toast.tone === 'error' ? danger : T.grn, fontWeight: 700 }}>{toast.tone === 'error' ? '!' : '✓'}</span>
          <span style={{ flex: 1 }}>{toast.message}</span>
          {toast.link && <button style={linkBtn(isDark)} onClick={() => { navigate(toast.link!.to); setToast(null); }}>{toast.link.label}</button>}
          <button aria-label="Dismiss" onClick={() => setToast(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: muted, fontSize: 14 }}>×</button>
        </div>
      )}
    </div>
  );
}

/* ─── Side panel ───────────────────────────────────────────────────── */

function VendorPanel({ vendor: v, isDark, canEdit, canDelete, visible, onClose, onOpen, onScan, onDelete }: {
  vendor: Vendor; isDark: boolean; canEdit: boolean; canDelete: boolean; visible: boolean;
  onClose: () => void; onOpen: () => void; onScan: (depth: ScanDepth) => void; onDelete: () => void;
}) {
  const panelRef = useRef<HTMLElement>(null);

  // Click anywhere outside closes the drawer; clicks on a vendor row are left to the row, which switches vendor.
  useEffect(() => {
    const onDown = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (panelRef.current?.contains(target) || target.closest('[data-vendor-row], [role="menu"], [role="dialog"]')) return;
      onClose();
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [onClose]);

  const ink = isDark ? '#e2e8f0' : T.ink;
  const muted = isDark ? '#94a3b8' : T.muted;
  const line = isDark ? '#1f1f1f' : T.bdr;
  const surface = isDark ? '#0d0d0d' : T.surface;
  const surface2 = isDark ? '#141414' : T.surface2;
  const bucket = riskBucket(v);
  const reasons = attentionReasons(v);
  const left = daysUntil(v.contract_end_date);
  const delta = scoreDelta(v);

  const row = (label: string, value: React.ReactNode) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, fontSize: 12.5, padding: '6px 0', borderBottom: `1px solid ${surface2}` }}>
      <span style={{ color: muted }}>{label}</span>
      <span style={{ color: value ? ink : muted, textAlign: 'right' }}>{value || 'Not set'}</span>
    </div>
  );

  return (
    <>
      <aside ref={panelRef} data-vendor-panel role="dialog" aria-label={`${v.name} summary`} style={{
        position: 'fixed', top: APP_HEADER_HEIGHT, right: 0, bottom: 0, width: 'min(420px, 100vw)', zIndex: 1150, background: surface,
        borderLeft: `1px solid ${line}`, display: 'flex', flexDirection: 'column', fontFamily: sans,
        animation: `${visible ? 'vendorPanelIn' : 'vendorPanelOut'} ${PANEL_SLIDE_MS}ms ${visible ? 'ease-out' : 'ease-in'} forwards`,
      }}>
        <style>{`
          @keyframes vendorPanelIn { from { transform: translateX(100%); } to { transform: translateX(0); } }
          @keyframes vendorPanelOut { from { transform: translateX(0); } to { transform: translateX(100%); } }
          @media (prefers-reduced-motion: reduce) { aside[data-vendor-panel] { animation-duration: 1ms !important; } }
        `}</style>
        <div style={{ padding: '16px 18px', borderBottom: `1px solid ${line}`, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <VendorLogo name={v.name} domain={v.domain} size={40} isDark={isDark} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: ink }}>{v.name}</div>
            <a href={`https://${v.domain}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: isDark ? '#60A5FA' : T.blue, textDecoration: 'none' }}>{v.domain} ↗</a>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
              <Pill label={RISK[bucket].label === 'Not scanned' ? 'Not scanned' : `${RISK[bucket].label} risk`} color={RISK[bucket].color} isDark={isDark} />
              <Pill label={LIFECYCLE[v.lifecycle].label} color={LIFECYCLE[v.lifecycle].color} isDark={isDark} />
              {v.status === 'cold' && <Pill label="Inactive" color={T.slate} isDark={isDark} />}
              {v.monitoring_paused && <Pill label="Monitoring paused" color={T.slate} isDark={isDark} />}
              {v.deletedAt && <Pill label="Archived" color={T.slate} isDark={isDark} />}
            </div>
          </div>
          <button aria-label="Close" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: muted, lineHeight: 1 }}>×</button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 18px', display: 'grid', gap: 18, alignContent: 'start' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 16, alignItems: 'center', padding: 14, borderRadius: 8, background: surface2 }}>
            <div>
              <div style={{ fontSize: 10.5, fontWeight: 700, color: muted, textTransform: 'uppercase', letterSpacing: '.05em' }}>Risk score</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginTop: 4 }}>
                <span style={{ fontSize: 30, fontWeight: 800, color: v.score === null ? muted : RISK[bucket].color, lineHeight: 1 }}>{v.score ?? '—'}</span>
                <span style={{ fontSize: 12, color: muted }}>/ 100</span>
              </div>
              <div style={{ marginTop: 4, fontSize: 11.5, color: muted }}>
                {delta === null ? 'First scan' : <><Delta value={delta} isDark={isDark} /> vs previous scan</>}
              </div>
            </div>
            <div style={{ justifySelf: 'end', textAlign: 'right' }}>
              <Sparkline points={v.score_history} width={150} height={44} isDark={isDark} />
              <div style={{ fontSize: 11, color: muted, marginTop: 4 }}>
                {v.score_history.length >= 2 ? `Last ${v.score_history.length} scans` : 'Trend appears after a second scan'}
              </div>
            </div>
          </div>

          {reasons.length > 0 && (
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: ink, marginBottom: 6 }}>Needs attention</div>
              <div style={{ display: 'grid', gap: 6 }}>
                {reasons.map(r => (
                  <div key={r.label} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, color: ink }}>
                    <Dot color={r.level === 'high' ? '#DC2626' : r.level === 'medium' ? '#D97706' : '#94A3B8'} />{r.label}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div>
            <div style={{ fontSize: 12, fontWeight: 700, color: ink, marginBottom: 2 }}>Details</div>
            {row('Category', v.category)}
            {row('Business units', v.business_units.length ? v.business_units.join(', ') : null)}
            {row('Owner', v.owner_name)}
            {row('Business owner', v.business_owner)}
            {row('Data sensitivity', v.data_sensitivity ? SENSITIVITY[v.data_sensitivity] || v.data_sensitivity : null)}
            {v.data_sensitivity === 'pii' && row('PII records a year', v.pii_record_volume
              ? (PII_RECORD_VOLUMES.find(([key]) => key === v.pii_record_volume)?.[1] ?? v.pii_record_volume) : null)}
            {row('Location', v.location)}
            {row('Vendor since', v.vendor_since ? fmtDate(v.vendor_since) : null)}
            {row('Contract ends', v.contract_end_date ? `${fmtDate(v.contract_end_date)}${left !== null ? (left < 0 ? ' (expired)' : ` (${left} days)`) : ''}${v.auto_renew ? ' · auto-renews' : ''}` : null)}
            {row('Last scan', v.lastScan ? `${fmtDate(v.lastScan)} · ${ago(v.lastScan)}` : 'Never')}
          </div>
        </div>

        {!v.deletedAt && (
          <div style={{ padding: '12px 18px', borderTop: `1px solid ${line}`, display: 'grid', gap: 8 }}>
            <button style={{ ...topBtn(true, isDark), justifyContent: 'center' }} onClick={onOpen}>Open vendor</button>
            {(canEdit || canDelete) && (
              <div style={{ display: 'flex', gap: 8 }}>
                {canEdit && <ScanTypeButton label="Run scan" onPick={onScan} isDark={isDark} block placement="top" align="left" buttonStyle={{ ...topBtn(false, isDark), justifyContent: 'center' }} />}
                {canDelete && (
                  <button onClick={onDelete} style={{
                    ...topBtn(false, isDark), flex: 1, justifyContent: 'center', color: isDark ? '#F87171' : T.red,
                    borderColor: isDark ? '#7f1d1d' : T.redBdr, background: isDark ? '#1a0a0a' : T.redBg,
                  }}>Delete vendor</button>
                )}
              </div>
            )}
          </div>
        )}
      </aside>
    </>
  );
}

/* ─── Onboarding requests ──────────────────────────────────────────── */

function OnboardingRequests({ requests, canAdd, isDark, onAdd }: {
  requests: OnboardingRequest[]; canAdd: boolean; isDark: boolean; onAdd: (r: OnboardingRequest) => void;
}) {
  const muted = isDark ? '#94a3b8' : T.muted;
  const ink = isDark ? '#e2e8f0' : T.ink;
  if (requests.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '44px 16px' }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: ink }}>No approved requests waiting</div>
        <div style={{ fontSize: 12.5, color: muted, marginTop: 4 }}>Approve a request on the Pre Onboarding page and it will appear here to be finished off.</div>
      </div>
    );
  }
  return (
    <div style={{ overflowX: 'auto' }}>
      <div style={{ fontSize: 12, color: muted, padding: '10px 12px' }}>Approved in pre-onboarding and waiting to be added as a vendor.</div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {['Vendor', 'Screening score', 'Requested', 'Requested by', ''].map(h => <th key={h || 'action'} style={th(isDark)}>{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {requests.map(r => (
            <tr key={r.id}>
              <td style={td(isDark)}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <VendorLogo name={r.vendor_name} domain={r.domain} size={28} isDark={isDark} />
                  <div><div style={{ fontWeight: 600 }}>{r.vendor_name}</div><div style={{ fontSize: 11, color: muted }}>{r.domain}</div></div>
                </div>
              </td>
              <td style={td(isDark)}>
                {!r.scan ? <span style={{ color: muted }}>Not screened</span>
                  : r.scan.status === 'processing' ? 'Running…'
                  : `${r.scan.overall_score} / 100 · ${r.scan.risk_level}`}
              </td>
              <td style={{ ...td(isDark), color: muted }}>{fmtDate(r.created_at)}</td>
              <td style={{ ...td(isDark), color: muted }}>{r.requested_by_name || '—'}</td>
              <td style={{ ...td(isDark), textAlign: 'right' }}>
                {canAdd && <button style={topBtn(true, isDark)} onClick={() => onAdd(r)}>Add vendor</button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* ─── Bulk import vendors (CSV): upload -> review (logos + every extracted field) -> confirm ──── */

interface BulkImportRowResult {
  row: number;
  name: string | null;
  domain: string | null;
  vendor_id?: string;
  status: 'created' | 'skipped';
  detail?: string;
}

interface BulkPreviewRow {
  row: number;
  status: 'ready' | 'skipped';
  detail: string | null;
  name: string; domain: string; category: string; business_units: string[];
  location: string | null; contact_name: string | null; contact_email: string | null; contact_phone: string | null;
  parent_company: string | null; vendor_since: string | null;
  contract_start_date: string | null; contract_end_date: string | null; contract_value: number | null;
  auto_renew: boolean; renewal_notice_days: number; ytd_spend: number | null;
  owner_user_id: string | null; owner_name: string | null; business_owner: string | null;
  data_sensitivity: string | null;
}

const DATA_SENSITIVITY_LABEL: Record<string, string> = {
  none: 'No sensitive data', internal: 'Internal data', pii: 'Customer PII',
  financial: 'Financial data', regulated: 'Regulated data',
};
const bulkMoney = (v: number | null) => v == null ? null : `$${v.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
const bulkDay = (v: string | null) => {
  if (!v) return null;
  const [y, m, d] = v.slice(0, 10).split('-').map(Number);
  return y ? new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : null;
};

export function BulkImportModal({ isDark, onClose, onDone }: { isDark: boolean; onClose: () => void; onDone: (created: number) => void }) {
  const muted = isDark ? '#94a3b8' : T.muted;
  const ink = isDark ? '#e2e8f0' : T.ink;
  const line = isDark ? '#1f1f1f' : T.bdr;
  const surface = isDark ? '#0d0d0d' : T.surface;
  const soft = isDark ? '#141414' : T.surface2;
  const grn = isDark ? '#34d399' : T.grn;
  const red = isDark ? '#F87171' : T.red;

  const [step, setStep] = useState<'upload' | 'review' | 'done'>('upload');
  const [file, setFile] = useState<File | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [preview, setPreview] = useState<{ ready: number; skipped: number; rows: BulkPreviewRow[] } | null>(null);
  const [selected, setSelected] = useState<Set<number>>(new Set());
  const [result, setResult] = useState<{ created: number; skipped: number; results: BulkImportRowResult[] } | null>(null);

  const downloadTemplate = async () => {
    try {
      const { data } = await api.get('/v1/vendors/bulk-import/template', { responseType: 'blob' });
      const url = URL.createObjectURL(data);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'vendor_bulk_import_template.csv';
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      setError('Could not download the template. Try again.');
    }
  };

  const upload = async () => {
    if (!file) return;
    setBusy(true);
    setError('');
    const formData = new FormData();
    formData.append('file', file);
    try {
      const { data } = await api.post('/v1/vendors/bulk-import', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setPreview(data);
      setSelected(new Set(data.rows.filter((r: BulkPreviewRow) => r.status === 'ready').map((r: BulkPreviewRow) => r.row)));
      setStep('review');
    } catch (err: any) {
      const d = err?.response?.data?.detail;
      setError(typeof d === 'string' ? d : (d && typeof d === 'object' && typeof d.message === 'string') ? d.message : 'Upload failed. Try again.');
    } finally {
      setBusy(false);
    }
  };

  const toggleRow = (row: number) => setSelected(prev => {
    const next = new Set(prev);
    next.has(row) ? next.delete(row) : next.add(row);
    return next;
  });

  const confirm = async () => {
    if (!preview) return;
    const rows = preview.rows.filter(r => r.status === 'ready' && selected.has(r.row));
    if (!rows.length) return;
    setBusy(true);
    setError('');
    try {
      const { data } = await api.post('/v1/vendors/bulk-import/confirm', { rows });
      setResult(data);
      setStep('done');
    } catch (err: any) {
      const d = err?.response?.data?.detail;
      setError(typeof d === 'string' ? d : (d && typeof d === 'object' && typeof d.message === 'string') ? d.message : 'Could not add these vendors. Try again.');
    } finally {
      setBusy(false);
    }
  };

  const field = (label: string, value: React.ReactNode) => value ? (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 9.5, fontWeight: 700, color: muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>{label}</div>
      <div style={{ fontSize: 12, color: ink, marginTop: 1, overflowWrap: 'anywhere' }}>{value}</div>
    </div>
  ) : null;

  const reviewWidth = step === 'review' ? 760 : 520;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: 16 }}
      onMouseDown={e => { if (e.target === e.currentTarget && !busy) onClose(); }}>
      <div role="dialog" aria-modal="true" aria-label="Bulk import vendors" style={{
        width: '100%', maxWidth: reviewWidth, maxHeight: '88vh', display: 'flex', flexDirection: 'column', background: surface,
        border: `1px solid ${line}`, borderRadius: 10, padding: 20, fontFamily: sans, transition: 'max-width .15s ease',
      }}>
        {step === 'upload' && (
          <>
            <div style={{ fontSize: 15, fontWeight: 700, color: ink, marginBottom: 6 }}>Bulk import vendors</div>
            <div style={{ fontSize: 12, color: muted, marginBottom: 14, lineHeight: 1.55 }}>
              One row per vendor -- name and domain are the only required columns. The template also covers
              relationship (owner, business owner, parent company, vendor since), contract &amp; spend, and data
              sensitivity, the same fields the single Add Vendor form has (<code>business_units</code> separated
              by <code>;</code>; owner matched by <code>owner_email</code>, since a CSV can't carry a team
              member's id). You'll review every vendor extracted from the file -- nothing is added until you
              confirm.{' '}
              <button onClick={downloadTemplate} style={{ ...linkBtn(isDark), fontSize: 12, padding: 0 }}>Download template</button>
            </div>
            <input type="file" accept=".csv" onChange={e => setFile(e.target.files?.[0] || null)} style={{ fontSize: 12.5, color: ink, marginBottom: 14 }} />
            {error && <div style={{ fontSize: 12, color: red, marginBottom: 12 }} role="alert">{error}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button type="button" style={topBtn(false, isDark)} onClick={onClose} disabled={busy}>Cancel</button>
              <button type="button" style={{ ...topBtn(true, isDark), opacity: (!file || busy) ? 0.6 : 1 }} onClick={upload} disabled={!file || busy}>
                {busy ? 'Reading file…' : 'Upload & review'}
              </button>
            </div>
          </>
        )}

        {step === 'review' && preview && (
          <>
            <div style={{ fontSize: 15, fontWeight: 700, color: ink, marginBottom: 2 }}>Review before adding</div>
            <div style={{ fontSize: 12, color: muted, marginBottom: 12 }}>
              Extracted from your file -- check what will actually be added. <strong style={{ color: ink }}>{selected.size}</strong> of{' '}
              {preview.rows.length} row{preview.rows.length === 1 ? '' : 's'} selected
              {preview.skipped > 0 && <span> &middot; {preview.skipped} can't be imported (see why below)</span>}.
            </div>
            <div style={{ flex: 1, overflow: 'auto', display: 'grid', gap: 8, marginBottom: 14, paddingRight: 2 }}>
              {preview.rows.map(r => {
                const ready = r.status === 'ready';
                const checked = ready && selected.has(r.row);
                const details = [
                  field('Category', r.category),
                  field('Business units', r.business_units?.length ? r.business_units.join(', ') : null),
                  field('Location', r.location),
                  field('Contact', [r.contact_name, r.contact_email].filter(Boolean).join(' · ') || r.contact_phone),
                  field('Owner', r.owner_name),
                  field('Business owner', r.business_owner),
                  field('Parent company', r.parent_company),
                  field('Vendor since', bulkDay(r.vendor_since)),
                  field('Data sensitivity', r.data_sensitivity ? DATA_SENSITIVITY_LABEL[r.data_sensitivity] : null),
                  field('Contract', r.contract_start_date || r.contract_end_date
                    ? `${bulkDay(r.contract_start_date) || '—'} → ${bulkDay(r.contract_end_date) || '—'}${r.auto_renew ? ' · auto-renews' : ''}` : null),
                  field('Contract value', bulkMoney(r.contract_value)),
                  field('YTD spend', bulkMoney(r.ytd_spend)),
                ].filter(Boolean);
                return (
                  <div key={r.row} style={{
                    display: 'flex', gap: 10, padding: '10px 12px', borderRadius: 8,
                    border: `1px solid ${ready ? line : (isDark ? '#3f1d1d' : '#FCA5A5')}`,
                    background: ready ? 'transparent' : (isDark ? 'rgba(248,113,113,.06)' : '#FEF2F2'), opacity: ready ? 1 : 0.85,
                  }}>
                    <input type="checkbox" checked={checked} disabled={!ready} onChange={() => toggleRow(r.row)} style={{ marginTop: 3, flexShrink: 0 }} />
                    <VendorLogo name={r.name || '?'} domain={r.domain} size={32} isDark={isDark} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: ink }}>{r.name || `Row ${r.row}`}</span>
                        <span style={{ fontSize: 11.5, color: muted }}>{r.domain}</span>
                        {!ready && <span style={{ fontSize: 10.5, fontWeight: 700, color: red }}>{r.detail}</span>}
                      </div>
                      {details.length > 0 && (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '6px 12px', marginTop: 8 }}>
                          {details}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            {error && <div style={{ fontSize: 12, color: red, marginBottom: 10 }} role="alert">{error}</div>}
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              <button type="button" style={topBtn(false, isDark)} onClick={() => { setStep('upload'); setPreview(null); setFile(null); }} disabled={busy}>
                ← Choose a different file
              </button>
              <div style={{ display: 'flex', gap: 8 }}>
                <button type="button" style={topBtn(false, isDark)} onClick={onClose} disabled={busy}>Cancel</button>
                <button type="button" style={{ ...topBtn(true, isDark), opacity: (!selected.size || busy) ? 0.6 : 1 }} onClick={confirm} disabled={!selected.size || busy}>
                  {busy ? 'Adding…' : `Add ${selected.size} vendor${selected.size === 1 ? '' : 's'}`}
                </button>
              </div>
            </div>
          </>
        )}

        {step === 'done' && result && (
          <>
            <div style={{ fontSize: 15, fontWeight: 700, color: ink, marginBottom: 6 }}>Bulk import vendors</div>
            <div style={{ fontSize: 12.5, color: ink, marginBottom: 12 }}>
              <strong>{result.created}</strong> created, <strong>{result.skipped}</strong> skipped.
            </div>
            <div style={{ border: `1px solid ${line}`, borderRadius: 6, marginBottom: 14, maxHeight: 300, overflow: 'auto', background: soft }}>
              {result.results.map((r, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', fontSize: 12, borderTop: i === 0 ? 'none' : `1px solid ${line}` }}>
                  <span style={{ flexShrink: 0, width: 60, fontWeight: 700, fontSize: 10, textTransform: 'uppercase', color: r.status === 'created' ? grn : muted }}>{r.status}</span>
                  <span style={{ color: ink, flexShrink: 0 }}>{r.name || `Row ${r.row}`}</span>
                  {r.detail && <span style={{ color: muted }}>&middot; {r.detail}</span>}
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button type="button" style={topBtn(true, isDark)} onClick={() => onDone(result.created)}>Done</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
